var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoInvestocenka3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2166,
    height: 571,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1301.5 0 L 1314 0 L 1314 27 L 1347 27 L 1347 0 L 1359.5 0 L 1359.5 1 L 1348 1 L 1348 28 L 1313 28 L 1313 1 L 1301.5 1 L 1301.5 0 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1458.5 0 L 1461 0.5 L 1458.5 1 L 1458.5 0 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1466.5 0 L 1472 2.5 L 1470.5 2 L 1466.5 1 L 1466.5 0 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1501 0 L 1514 0.5 L 1502 1 L 1501.5 61 L 1501 0 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1556.5 0 L 1558.5 0 L 1563 4.5 L 1564 9.5 L 1563 9.5 Q 1562.9 3.1 1558.5 1 Q 1555.5 1.5 1556.5 0 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1568 0 L 1632 0.5 L 1569 1 L 1568.5 11 L 1568 0 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1636 0 L 1649 0.5 L 1637 1 L 1636.5 60 L 1636 0 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1684.5 0 L 1686 0.5 L 1679.5 5 L 1682.5 1 L 1684.5 0 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1692.5 0 L 1695 1.5 L 1693.5 1 L 1692.5 0 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1709.5 0 L 1722 0 L 1722 21.5 L 1721 21.5 L 1721 1 L 1709.5 1 L 1709.5 0 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1753 0 L 1766 0.5 L 1754 1 L 1754 27.5 L 1752.5 29 L 1727 28.5 L 1753 28 L 1753 0 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1786.5 0 L 1829.5 0 L 1830 0.5 L 1830 10.5 L 1829 10.5 L 1829 1.5 L 1828.5 1 L 1786.5 1 L 1786.5 0 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1861.5 0 L 1891 0 L 1891 10.5 L 1890 10.5 L 1890 1.5 L 1889.5 1 L 1861.5 1 L 1861.5 0 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1899 0 L 1912 0.5 L 1900 1 L 1900 65.5 L 1900.5 66 L 1911.5 66 L 1911.5 67 L 1899.5 67 L 1899 66.5 L 1899 0 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1943.5 0 L 1958.5 0 L 1959 1.5 L 1948 11.5 L 1957.5 1 L 1943.5 1 L 1918 26.5 L 1916.5 30 L 1916 28.5 L 1943.5 0 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1995.5 0 L 1999 1.5 L 1997.5 1 Q 1994.5 1.5 1995.5 0 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2045.5 0 L 2080 0.5 L 2045.5 1 L 2045.5 0 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 627.5 1 L 699 1.5 L 627.5 2 L 627.5 1 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 754.5 1 L 838.5 1 L 839 1.5 L 839 19.5 L 838 19.5 L 838 2.5 L 837.5 2 L 754.5 2 L 754.5 1 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 872.5 1 L 948.5 1 L 949 1.5 L 949 19.5 L 948 19.5 L 948 2.5 L 947.5 2 L 872.5 2 L 872.5 1 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 954 1 L 1074 1.5 L 955 2 L 954.5 20 L 954 1 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1391.5 1 L 1388.5 5 L 1391.5 1 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1404.5 1 L 1407.5 5 L 1404.5 1 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1456.5 1 L 1454.5 4 L 1456.5 1 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1547.5 1 L 1543.5 6 L 1547.5 1 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1781.5 1 L 1783 1.5 L 1778.5 5 L 1781.5 1 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1854.5 1 L 1857 1.5 L 1854.5 2 L 1854.5 1 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1985.5 1 L 1983.5 4 L 1985.5 1 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2038.5 1 L 2041 1.5 Q 2035.4 2.4 2033 6.5 L 2030.5 13 L 2030 10.5 L 2036.5 2 L 2038.5 1 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2082.5 1 L 2087 3.5 L 2085.5 3 Q 2081.7 2.8 2082.5 1 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 701.5 2 L 704 2.5 L 701.5 3 L 701.5 2 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 749.5 2 L 752 2.5 Q 746.4 3.4 744 7.5 L 742.5 11 L 742 9.5 L 747.5 3 L 749.5 2 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 866.5 2 L 869 2.5 L 866.5 3 L 866.5 2 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1851.5 2 L 1853 2.5 L 1849.5 4 L 1849.5 3 L 1851.5 2 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 705.5 3 L 710 5.5 L 708.5 5 Q 704.8 4.8 705.5 3 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 619.5 4 L 618 6.5 L 616.5 9 L 617 7.5 L 619.5 4 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1472.5 4 L 1474 6.5 L 1473 6.5 L 1472.5 4 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1847.5 4 L 1846.5 6 L 1847.5 4 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2001.5 4 L 2004 8.5 L 2003 8.5 L 2001.5 4 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 860.5 5 L 853.5 13 L 860.5 5 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1982.5 5 L 1982 6.5 L 1981.5 8 L 1981 6.5 L 1982.5 5 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 711.5 6 L 715.5 11 L 711.5 6 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1387.5 6 L 1388 7.5 L 1386.5 10 L 1386 8.5 L 1387.5 6 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1678.5 6 L 1677.5 8 L 1678.5 6 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1844.5 6 L 1842.5 9 L 1844.5 6 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1452.5 7 L 1453 8.5 L 1451.5 11 L 1451 9.5 L 1452.5 7 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1542.5 7 L 1542 8.5 L 1540.5 11 L 1541 9.5 L 1542.5 7 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2088.5 7 L 2089 67 L 2076 66.5 L 2088 66 L 2088.5 7 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1409.5 8 L 1411 11.5 L 1410 11.5 L 1409.5 8 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1474.5 8 L 1476 11.5 L 1475 11.5 L 1474.5 8 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1676.5 9 L 1676 10.5 L 1674.5 13 L 1675 11.5 L 1676.5 9 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1841.5 10 L 1840.5 12 L 1841.5 10 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1606.5 11 L 1607 67 L 1594 66.5 L 1606 66 L 1606.5 11 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1859.5 11 L 1862 11.5 L 1853.5 16 L 1855.5 13 L 1859.5 11 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1979.5 11 L 1980 12.5 L 1978.5 15 L 1978 13.5 L 1979.5 11 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1992.5 11 L 1994 13.5 L 1993 13.5 L 1992.5 12 L 1991 12.5 L 1992.5 11 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2046.5 11 L 2048 11.5 L 2044 14.5 L 2043.5 16 L 2043 14.5 L 2046.5 11 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2074.5 11 L 2076 13.5 L 2075 13.5 L 2074.5 11 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 716.5 12 L 719 16.5 L 718 16.5 L 716.5 12 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1397.5 12 L 1397 13.5 L 1395.5 17 L 1395 15.5 L 1397.5 12 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1462.5 12 L 1465 13.5 L 1466 16.5 L 1465 16.5 L 1464 13 L 1462.5 12 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1539.5 12 L 1539 13.5 L 1537.5 16 L 1538 14.5 L 1539.5 12 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1946.5 12 L 1928.5 31 L 1946.5 12 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2005.5 12 L 2007 15.5 L 2006 15.5 L 2005.5 12 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 614.5 13 L 615 16.5 L 614 16.5 L 614.5 13 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1384.5 13 L 1385 14.5 L 1383.5 17 L 1383 15.5 L 1384.5 13 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1399.5 13 L 1401 16.5 L 1400 16.5 L 1399.5 13 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1789.5 13 L 1790 27.5 L 1789 27.5 L 1789.5 13 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1449.5 14 L 1450 15.5 L 1448.5 18 L 1448 16.5 L 1449.5 14 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1461.5 14 L 1462 15.5 L 1460.5 18 L 1460 16.5 L 1461.5 14 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1550.5 14 L 1552 15.5 L 1552 53.5 L 1551 53.5 L 1550.5 15 L 1546.5 21 L 1547 19.5 L 1550.5 14 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1673.5 14 L 1673 15.5 L 1671.5 18 L 1672 16.5 L 1673.5 14 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1685.5 14 Q 1687.8 13.3 1687 15.5 L 1685.5 14 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1412.5 15 L 1414 18.5 L 1413 18.5 L 1412.5 15 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1477.5 15 L 1479 18.5 L 1478 18.5 L 1477.5 15 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1513.5 15 L 1514.5 52 L 1517.5 48 L 1517 49.5 L 1514.5 53 L 1513 51.5 L 1513.5 15 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2029.5 15 L 2030 26.5 L 2029 26.5 L 2029.5 15 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1684.5 16 L 1683.5 18 L 1684.5 16 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1977.5 16 L 1978 17.5 L 1976.5 20 L 1976 18.5 L 1977.5 16 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 740.5 17 L 741 108.5 L 740 108.5 L 740.5 17 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1536.5 17 L 1535.5 19 L 1536.5 17 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1852.5 17 L 1852 18.5 L 1851.5 20 L 1851 18.5 L 1852.5 17 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2007.5 17 L 2009 20.5 L 2008 20.5 L 2007.5 17 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2042.5 17 L 2043 26.5 L 2042 26.5 L 2042.5 17 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 719.5 18 L 720 20.5 L 719 20.5 L 719.5 18 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1394.5 18 L 1395 19.5 L 1393.5 22 L 1393 20.5 L 1394.5 18 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1401.5 18 L 1403 21.5 L 1402 21.5 L 1401.5 18 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1466.5 18 L 1468 21.5 L 1467 21.5 L 1466.5 18 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1837.5 18 L 1838 20.5 L 1837 20.5 L 1837.5 18 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 850.5 19 L 851 22.5 L 850 22.5 L 850.5 19 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1670.5 19 L 1669.5 21 L 1670.5 19 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1682.5 19 L 1682 20.5 L 1680.5 23 L 1681 21.5 L 1682.5 19 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 687.5 20 L 690 20.5 L 687.5 21 L 687.5 20 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 767.5 20 L 769 20.5 L 765 23.5 L 764.5 25 L 764 23.5 L 767.5 20 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 879.5 20 L 882 20.5 L 879.5 21 L 879.5 20 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1002.5 20 L 1003 124 L 1024.5 124 L 1025 123.5 L 1025 20.5 L 1026 20.5 L 1026 124.5 L 1025.5 125 L 1002 125 L 1002.5 20 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1381.5 20 L 1382 21.5 L 1380.5 24 L 1380 22.5 L 1381.5 20 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1414.5 20 L 1417 25.5 L 1416 25.5 L 1414.5 20 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1534.5 20 L 1534 21.5 L 1532.5 24 L 1533 22.5 L 1534.5 20 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 691.5 21 Q 696.4 23.1 697 29.5 L 696 29.5 L 695 25.5 L 691.5 21 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 877.5 21 L 874.5 25 L 877.5 21 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1446.5 21 L 1447 22.5 L 1445.5 25 L 1445 23.5 L 1446.5 21 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1987.5 21 L 1988 22.5 L 1986.5 25 L 1986 23.5 L 1987.5 21 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 720.5 22 L 721 24.5 L 720 24.5 L 720.5 22 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1480.5 22 L 1482 25.5 L 1481 25.5 L 1480.5 22 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1545.5 22 L 1545 23.5 L 1543.5 26 L 1544 24.5 L 1545.5 22 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1668.5 22 L 1668 23.5 L 1666.5 26 L 1667 24.5 L 1668.5 22 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1392.5 23 L 1393 24.5 L 1391.5 27 L 1391 25.5 L 1392.5 23 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1403.5 23 L 1405 26.5 L 1404 26.5 L 1403.5 23 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1468.5 23 L 1470 26.5 L 1469 26.5 L 1468.5 23 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1836.5 23 L 1837 28.5 L 1836 28.5 L 1836.5 23 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1974.5 23 L 1975 24.5 L 1973.5 27 L 1973 25.5 L 1974.5 23 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 637.5 24 L 638 52.5 L 637 52.5 L 637.5 24 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1679.5 24 L 1679 25.5 L 1675.5 31 L 1676 29.5 L 1679.5 24 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1722.5 24 L 1724.5 27 L 1726 27.5 L 1724.5 28 Q 1720.9 26.9 1722.5 24 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1849.5 24 L 1850 29.5 L 1849 29.5 L 1849.5 24 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2010.5 24 L 2012 27.5 L 2011 27.5 L 2010.5 24 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1379.5 25 L 1380 26.5 L 1378.5 29 L 1378 27.5 L 1379.5 25 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1531.5 25 L 1531 26.5 L 1529.5 29 L 1530 27.5 L 1531.5 25 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1686.5 25 L 1687 66 L 1699 66.5 L 1686 67 L 1686.5 25 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1709.5 25 L 1710 28.5 L 1709 28.5 L 1709.5 25 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 849.5 26 L 850 37.5 L 849 37.5 L 849.5 26 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 873.5 26 L 874 28.5 L 873 28.5 L 873.5 26 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1444.5 26 L 1445 27.5 L 1443.5 30 L 1443 28.5 L 1444.5 26 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1985.5 26 L 1986 27.5 L 1984.5 30 L 1984 28.5 L 1985.5 26 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1417.5 27 L 1419 30.5 L 1418 30.5 L 1417.5 27 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1482.5 27 L 1484 30.5 L 1483 30.5 L 1482.5 27 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1542.5 27 L 1541.5 29 L 1542.5 27 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1665.5 27 L 1665 28.5 L 1663.5 31 L 1664 29.5 L 1665.5 27 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1390.5 28 L 1391 29.5 L 1389.5 32 L 1389 30.5 L 1390.5 28 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1405.5 28 L 1407 31.5 L 1406 31.5 L 1405.5 28 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1470.5 28 L 1472 31.5 L 1471 31.5 L 1470.5 28 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1828.5 28 L 1829 37.5 L 1828 37.5 L 1828.5 28 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1972.5 28 L 1973 29.5 L 1971.5 32 L 1971 30.5 L 1972.5 28 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 721.5 30 L 722 39.5 L 721 39.5 L 721.5 30 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1528.5 30 L 1528 31.5 L 1526.5 34 L 1527 32.5 L 1528.5 30 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1540.5 30 L 1540 31.5 L 1538.5 34 L 1539 32.5 L 1540.5 30 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1915.5 31 L 1916 33.5 L 1915 33.5 L 1915.5 31 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1983.5 31 L 1984 32.5 L 1982.5 35 L 1982 33.5 L 1983.5 31 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2013.5 31 L 2015 34.5 L 2014 34.5 L 2013.5 31 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2030.5 31 L 2032 35.5 L 2031 35.5 L 2030.5 31 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2044.5 31 L 2047.5 33 L 2065 33.5 L 2047.5 34 L 2044.5 31 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1376.5 32 L 1377 33.5 L 1375.5 36 L 1375 34.5 L 1376.5 32 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1454.5 32 L 1455 33.5 L 1453.5 36 L 1453 34.5 L 1454.5 32 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1662.5 32 L 1662 33.5 L 1660.5 36 L 1661 34.5 L 1662.5 32 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1674.5 32 L 1674 33.5 L 1672.5 36 L 1673 34.5 L 1674.5 32 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1711.5 32 L 1715.5 37 L 1711.5 32 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1388.5 33 L 1389 34.5 L 1387.5 37 L 1387 35.5 L 1388.5 33 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1407.5 33 L 1409 36.5 L 1408 36.5 L 1407.5 33 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1441.5 33 L 1442 34.5 L 1440.5 37 L 1440 35.5 L 1441.5 33 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1472.5 33 L 1474 36.5 L 1473 36.5 L 1472.5 33 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 697.5 34 L 698 39.5 L 697 39.5 L 697.5 34 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1420.5 34 L 1422 37.5 L 1421 37.5 L 1420.5 34 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1485.5 34 L 1487 37.5 L 1486 37.5 L 1485.5 34 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1928.5 34 L 1935.5 42 L 1945 50.5 L 1936.5 43 L 1928 35.5 L 1928.5 34 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 873.5 35 Q 874.4 40.6 878.5 43 L 884 45.5 L 882.5 46 L 874 39.5 L 873.5 35 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1525.5 35 L 1524.5 37 L 1525.5 35 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1537.5 35 L 1537 36.5 L 1533.5 42 L 1534 40.5 L 1537.5 35 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1969.5 35 L 1970 36.5 L 1968.5 39 L 1968 37.5 L 1969.5 35 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1981.5 36 L 1982 37.5 L 1980.5 40 L 1980 38.5 L 1981.5 36 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2015.5 36 L 2017 39.5 L 2016 39.5 L 2015.5 36 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2068.5 36 L 2069 40.5 L 2068 40.5 L 2068.5 36 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1314.5 37 L 1346.5 37 L 1348 38.5 L 1348 66 L 1359.5 66 L 1359.5 67 L 1347 67 L 1347 38 L 1314 38 L 1314 67 L 1301.5 67 L 1301.5 66 L 1313 66 L 1313 38.5 L 1314.5 37 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1452.5 37 L 1453 38.5 L 1451.5 41 L 1451 39.5 L 1452.5 37 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1659.5 37 L 1658.5 39 L 1659.5 37 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1671.5 37 L 1670.5 39 L 1671.5 37 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2032.5 37 L 2036.5 42 L 2032.5 37 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1386.5 38 L 1387 39.5 L 1385 40.5 L 1386.5 38 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1409.5 38 L 1411 40.5 L 1409 39.5 L 1409.5 38 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1523.5 38 L 1523 39.5 L 1521.5 42 L 1522 40.5 L 1523.5 38 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1720.5 38 L 1752.5 38 L 1754 39.5 L 1754 66 L 1765.5 66 L 1765.5 67 L 1753 67 L 1753 39 L 1720.5 39 L 1720.5 38 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1789.5 38 L 1790 53.5 L 1789 53.5 L 1789.5 38 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1917.5 38 L 1934.5 56 L 1920.5 42 L 1919 42 L 1917.5 38 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1373.5 39 L 1374 40.5 L 1372.5 43 L 1372 41.5 L 1373.5 39 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1422.5 39 L 1424 42.5 L 1423 42.5 L 1422.5 39 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1487.5 39 L 1490 44.5 L 1489 44.5 L 1487.5 39 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1836.5 39 L 1837 44.5 L 1836 44.5 L 1836.5 39 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1849.5 39 L 1850 43.5 L 1849 43.5 L 1849.5 39 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1438.5 40 L 1439 41.5 L 1437.5 44 L 1437 42.5 L 1438.5 40 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1657.5 40 L 1657 41.5 L 1655.5 44 L 1656 42.5 L 1657.5 40 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1669.5 40 L 1669 41.5 L 1667.5 44 L 1668 42.5 L 1669.5 40 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 850.5 41 L 851 43.5 L 850 43.5 L 850.5 41 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1450.5 42 L 1451 43.5 L 1449.5 46 L 1449 44.5 L 1450.5 42 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1966.5 42 L 1967 43.5 L 1965.5 46 L 1965 44.5 L 1966.5 42 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 696.5 43 L 697 45.5 L 691.5 52 L 695 47.5 L 696.5 43 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 720.5 43 L 721 46.5 L 720 46.5 L 720.5 43 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1520.5 43 L 1520 44.5 L 1518.5 47 L 1519 45.5 L 1520.5 43 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1532.5 43 L 1532 44.5 L 1530.5 47 L 1531 45.5 L 1532.5 43 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2018.5 43 L 2020 46.5 L 2019 46.5 L 2018.5 43 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2040.5 43 L 2051.5 43 L 2052 44.5 L 2046 49.5 L 2050.5 44 L 2040.5 44 L 2040.5 43 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1371.5 44 L 1372 45.5 L 1370.5 48 L 1370 46.5 L 1371.5 44 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1648.5 44 L 1649 50.5 L 1648 50.5 L 1648.5 44 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2066.5 44 L 2055.5 56 L 2043.5 67 L 2014 67 L 2013 63.5 L 2014 63.5 L 2015.5 66 L 2026.5 66 L 2027 64.5 L 2026 62.5 L 2027 62.5 L 2028.5 65 L 2044.5 50 L 2035.5 60 L 2029 65.5 L 2043.5 66 L 2066.5 44 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1436.5 45 L 1437 46.5 L 1434.5 51 L 1434 49.5 L 1436.5 45 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1654.5 45 L 1654 46.5 L 1652.5 49 L 1653 47.5 L 1654.5 45 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1666.5 45 L 1666 46.5 L 1662.5 52 L 1663 50.5 L 1666.5 45 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1850.5 45 Q 1851.5 51 1856 53.5 L 1851 49.5 L 1850.5 45 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1425.5 46 L 1427 49.5 L 1426 49.5 L 1425.5 46 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1477.5 46 L 1479 49.5 L 1478 49.5 L 1477.5 46 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1490.5 46 L 1492 49.5 L 1491 49.5 L 1490.5 46 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1448.5 47 L 1449 48.5 L 1447.5 51 L 1447 49.5 L 1448.5 47 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1964.5 47 L 1965 48.5 L 1963.5 51 L 1963 49.5 L 1964.5 47 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 719.5 48 L 720 49.5 L 712.5 59 L 716 54.5 L 719.5 48 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 852.5 48 L 858.5 57 L 862 59.5 L 859.5 58 L 855 54.5 L 852 49.5 L 852.5 48 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 891.5 48 L 897 49.5 L 894.5 50 L 891.5 49 L 891.5 48 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1529.5 48 L 1528.5 50 L 1529.5 48 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2020.5 48 L 2023 53.5 L 2022 53.5 L 2020.5 48 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1651.5 50 L 1649.5 53 L 1651.5 50 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1368.5 51 L 1369 52.5 L 1367.5 55 L 1367 53.5 L 1368.5 51 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1414.5 51 L 1416 54.5 L 1415 54.5 L 1414.5 51 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1479.5 51 L 1481 54.5 L 1480 54.5 L 1479.5 51 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1527.5 51 L 1527 52.5 L 1525.5 55 L 1526 53.5 L 1527.5 51 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1946.5 51 L 1953.5 59 L 1946.5 51 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 685.5 52 L 690 52.5 L 685.5 53 L 685.5 52 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1433.5 52 L 1434 53.5 L 1432.5 56 L 1432 54.5 L 1433.5 52 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1446.5 52 L 1447 53.5 L 1445.5 56 L 1445 54.5 L 1446.5 52 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1975.5 52 L 1976 53.5 L 1974.5 56 L 1974 54.5 L 1975.5 52 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1428.5 53 L 1430 56.5 L 1429 56.5 L 1428.5 53 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1493.5 53 L 1495 56.5 L 1494 56.5 L 1493.5 53 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1661.5 53 L 1661 54.5 L 1659.5 57 L 1660 55.5 L 1661.5 53 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1839.5 53 L 1841 55.5 L 1839 54.5 L 1839.5 53 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2009.5 53 L 2011 56.5 L 2010 56.5 L 2009.5 53 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 910.5 54 L 916 55.5 L 913.5 56 L 910.5 55 L 910.5 54 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1961.5 54 L 1962 55.5 L 1960.5 58 L 1960 56.5 L 1961.5 54 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1859.5 55 L 1862 55.5 L 1859.5 56 L 1859.5 55 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2023.5 55 L 2025 58.5 L 2024 58.5 L 2023.5 55 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1366.5 56 L 1367 57.5 L 1365.5 60 L 1365 58.5 L 1366.5 56 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1416.5 56 L 1418 59.5 L 1417 59.5 L 1416.5 56 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1481.5 56 L 1483 59.5 L 1482 59.5 L 1481.5 56 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1524.5 56 L 1523.5 58 L 1524.5 56 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1792.5 56 L 1830 56.5 L 1792.5 57 L 1792.5 56 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1865.5 56 L 1892 56 L 1892 67 L 1859 66.5 L 1891 66 L 1891 57 L 1865.5 57 L 1865.5 56 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1936.5 56 L 1946.5 66 L 1970 66 L 1971.5 62 L 1972 63.5 L 1969.5 67 L 1946.5 67 L 1936.5 56 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1431.5 57 L 1430.5 59 L 1431.5 57 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1444.5 57 L 1445 58.5 L 1443.5 61 L 1443 59.5 L 1444.5 57 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1841.5 57 L 1845.5 62 L 1841.5 57 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1973.5 57 L 1974 58.5 L 1972.5 61 L 1972 59.5 L 1973.5 57 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1495.5 58 L 1497 61.5 L 1496 61.5 L 1495.5 58 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1658.5 58 L 1657.5 60 L 1658.5 58 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2011.5 58 L 2013 61.5 L 2012 61.5 L 2011.5 58 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1522.5 59 L 1522 60.5 L 1516.5 67 L 1514 66.5 Q 1519.5 66 1521 61.5 L 1522.5 59 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1777.5 59 L 1778 61.5 L 1777 61.5 L 1777.5 59 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1955.5 59 L 1959 61 L 1959.5 59 L 1960 60.5 L 1958.5 63 L 1955.5 59 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 704.5 61 L 711 63.5 L 709.5 64 L 704.5 62 L 704.5 61 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1418.5 61 L 1420 64.5 L 1419 64.5 L 1418.5 61 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1483.5 61 L 1485 64.5 L 1484 64.5 L 1483.5 61 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1637.5 61 L 1639 65 L 1643 66.5 L 1641.5 67 L 1638 64.5 L 1637.5 61 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1656.5 61 L 1656 62.5 L 1653.5 66 L 1650.5 67 L 1650.5 66 L 1655 63.5 L 1656.5 61 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 867.5 62 L 872 63.5 L 869.5 64 L 867.5 62 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 935.5 62 L 939 63.5 L 937.5 64 L 935.5 62 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1502.5 62 L 1505 65.5 L 1502 63.5 L 1502.5 62 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1847.5 62 L 1852 64.5 L 1850.5 65 L 1847.5 62 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1363.5 63 L 1364 64.5 L 1363.5 66 L 1376 66.5 L 1362 67 L 1363.5 63 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1778.5 63 L 1782 65.5 L 1780.5 66 L 1778.5 63 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 712.5 64 L 720 70.5 L 722 75.5 L 721 75.5 Q 719.5 69 714.5 66 L 712.5 64 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 940.5 64 L 944 66.5 L 942.5 66 L 940.5 64 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1441.5 65 L 1440.5 67 L 1420 66.5 L 1440.5 66 L 1441.5 65 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1498.5 65 L 1499 67 L 1485 66.5 L 1497.5 66 L 1498.5 65 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1853.5 65 L 1856 65.5 L 1853.5 66 L 1853.5 65 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1551.5 66 L 1564 66.5 L 1551.5 67 L 1551.5 66 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1783.5 66 L 1830 66.5 L 1783.5 67 L 1783.5 66 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 945.5 67 L 951 73.5 L 949 72.5 L 945.5 67 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 885.5 68 L 891 69.5 L 888.5 70 L 885.5 69 L 885.5 68 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 637 71 L 688 71.5 L 638 72 L 637.5 101 L 637 71 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 690.5 72 L 698 77.5 L 697.5 79 L 693.5 74 Q 689.7 73.8 690.5 72 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 904.5 74 L 910 75.5 L 907.5 76 L 904.5 75 L 904.5 74 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 951.5 75 L 953 78.5 L 952 78.5 L 951.5 75 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 722.5 77 L 723 79.5 L 722 79.5 L 722.5 77 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 920.5 79 Q 926.3 80.3 929 84.5 L 925.5 82 L 920.5 80 L 920.5 79 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 698.5 80 L 699 82.5 L 698 82.5 L 698.5 80 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 953.5 80 L 954 82.5 L 953 82.5 L 953.5 80 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 723.5 84 L 724 93.5 L 723 93.5 L 723.5 84 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 954.5 85 L 955 99.5 L 954 99.5 L 954.5 85 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 930.5 88 L 931 96.5 L 930 96.5 L 930.5 88 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 698.5 94 L 699 96.5 L 698 96.5 L 698.5 94 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 697.5 98 L 698 99.5 L 693 103.5 L 697.5 98 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 722.5 100 L 723 104.5 L 722 104.5 L 722.5 100 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 764.5 101 L 767 104.5 L 764 102.5 L 764.5 101 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 928.5 101 L 925.5 105 L 924 104.5 L 928.5 101 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 638.5 102 L 640 104.5 L 638 103.5 L 638.5 102 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 953.5 103 L 954 105.5 L 953 105.5 L 953.5 103 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 641.5 105 L 688 105.5 L 641.5 106 L 641.5 105 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 768.5 105 L 839 105.5 L 768.5 106 L 768.5 105 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 851.5 105 L 923 105.5 L 851.5 106 L 851.5 105 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 721.5 107 L 722 108.5 L 717.5 115 L 719 112.5 L 721.5 107 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 614.5 109 L 615 112.5 L 614 112.5 L 614.5 109 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 951.5 110 L 952 111.5 L 950 112.5 L 951.5 110 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 741.5 112 L 742 114.5 L 741 114.5 L 741.5 112 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1321.5 113 L 1326 113.5 L 1321.5 114 L 1321.5 113 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1340.5 113 L 1345 113.5 L 1340.5 114 L 1340.5 113 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1530.5 113 L 1533 113.5 L 1530.5 114 L 1530.5 113 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1537.5 113 Q 1542.3 113.3 1544 116.5 L 1541.5 115 L 1537.5 114 L 1537.5 113 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1595.5 113 L 1598 113.5 L 1595.5 114 L 1595.5 113 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1602.5 113 Q 1608.1 113.5 1610 117.5 L 1611 120.5 L 1610 120.5 L 1606.5 115 L 1602.5 114 L 1602.5 113 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1754.5 113 L 1760 115.5 L 1758.5 116 L 1754.5 114 L 1754.5 113 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1920.5 113 L 1925 113.5 L 1920.5 114 L 1920.5 113 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1939.5 113 L 1945 113.5 L 1939.5 114 L 1939.5 113 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2065.5 113 L 2068 113.5 L 2065.5 114 L 2065.5 113 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2072.5 113 Q 2077.3 113.3 2079 116.5 L 2076.5 115 L 2072.5 114 L 2072.5 113 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 615.5 114 L 617 116.5 L 615 115.5 L 615.5 114 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 949.5 114 L 942.5 122 L 941 121.5 L 949.5 114 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1316.5 114 L 1319 114.5 L 1316.5 115 L 1316.5 114 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1347.5 114 L 1350 114.5 L 1347.5 115 L 1347.5 114 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1388.5 114 L 1389 140 L 1422 140 L 1422 114.5 L 1423 114.5 L 1423 141 L 1388 141 L 1388.5 114 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1463.5 114 L 1466 114.5 L 1463.5 115 L 1463.5 114 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1498.5 114 L 1499 123.5 L 1498 123.5 L 1498.5 114 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1528.5 114 L 1525 118.5 L 1523.5 122 L 1523 120.5 L 1526 115 L 1528.5 114 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1593.5 114 L 1591 117.5 L 1588.5 123 L 1588 121.5 L 1593.5 114 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1631.5 114 L 1632 123.5 L 1631 123.5 L 1631.5 114 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1699.5 114 L 1700 172.5 L 1699 172.5 L 1699.5 114 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1785.5 114 L 1786 140 L 1819 140 L 1819 114.5 L 1820 114.5 L 1820 141 L 1785 141 L 1785.5 114 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1847.5 114 L 1850 114.5 L 1844.5 118 L 1847.5 114 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1915.5 114 L 1918 114.5 L 1909.5 118 L 1910.5 116 L 1915.5 114 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1946.5 114 L 1949 114.5 L 1946.5 115 L 1946.5 114 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1979.5 114 L 1981 114.5 L 1976.5 118 L 1979.5 114 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2021.5 114 L 2027 116.5 L 2025.5 116 L 2021.5 115 L 2021.5 114 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2063.5 114 L 2060 118.5 L 2059.5 120 L 2059 118.5 L 2063.5 114 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2116.5 114 L 2120 114.5 L 2112 117 L 2108.5 124 L 2108 122.5 L 2112.5 116 L 2116.5 114 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1313.5 115 L 1315 115.5 Q 1308.1 117.6 1304.5 123 L 1309.5 117 L 1313.5 115 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1351.5 115 Q 1358.7 116.8 1362 122.5 L 1356.5 118 L 1351.5 116 L 1351.5 115 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1744.5 115 L 1743 117.5 L 1739.5 123 L 1740 121.5 L 1744.5 115 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2162.5 115 L 2164.5 118 L 2162.5 115 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 716.5 116 L 713.5 120 Q 710 123.5 703.5 124 L 703.5 123 Q 712.3 121.8 716.5 116 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 742.5 116 L 747.5 122 L 752 123.5 L 749.5 124 L 742 117.5 L 742.5 116 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1457.5 116 L 1459 116.5 L 1450.5 122 L 1452.5 119 L 1457.5 116 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1955.5 117 Q 1961.9 120.6 1964 128.5 L 1963 128.5 L 1961 123.5 L 1955.5 117 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 617.5 118 Q 620 122.5 626 123.5 L 623.5 124 L 617.5 118 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1907.5 118 L 1904 122.5 L 1902.5 125 L 1903 123.5 L 1907.5 118 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2079.5 118 L 2081 120.5 L 2080 120.5 L 2079.5 118 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1843.5 119 L 1844 121.5 L 1843 121.5 L 1843.5 119 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1975.5 119 L 1976 121.5 L 1975 121.5 L 1975.5 119 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2029.5 119 L 2032 124.5 L 2031 124.5 L 2029.5 119 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1546.5 122 L 1548 125.5 L 1547 125.5 L 1546.5 122 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1611.5 122 L 1613 125.5 L 1612 125.5 L 1611.5 122 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 933.5 123 L 937 123.5 L 933.5 124 L 933.5 123 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1325.5 123 L 1331 123.5 L 1325.5 124 L 1325.5 123 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1334.5 123 L 1341 123.5 L 1334.5 124 L 1334.5 123 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1449.5 123 L 1448.5 125 L 1449.5 123 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1522.5 123 L 1523 124.5 L 1521.5 127 L 1521 125.5 L 1522.5 123 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1924.5 123 L 1931 123.5 L 1924.5 124 L 1924.5 123 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1934.5 123 L 1940 123.5 L 1934.5 124 L 1934.5 123 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2057.5 123 L 2058 124.5 L 2056.5 127 L 2056 125.5 L 2057.5 123 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 633.5 124 L 698 124.5 L 633.5 125 L 633.5 124 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 757.5 124 L 839 124.5 L 757.5 125 L 757.5 124 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 851.5 124 L 928 124.5 L 851.5 125 L 851.5 124 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1303.5 124 L 1303 125.5 L 1302.5 127 L 1302 125.5 L 1303.5 124 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1343.5 124 L 1351 129.5 L 1346.5 126 Q 1342.8 125.7 1343.5 124 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1362.5 124 L 1364 126.5 L 1363 126.5 L 1362.5 124 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1468.5 124 L 1471 124.5 L 1468.5 125 L 1468.5 124 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1587.5 124 L 1588 125.5 L 1586.5 128 L 1586 126.5 L 1587.5 124 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1669.5 124 L 1670 180 L 1657 179.5 L 1669 179 L 1669.5 124 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1738.5 124 L 1738 125.5 L 1736.5 128 L 1737 126.5 L 1738.5 124 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1920.5 124 L 1922 124.5 L 1915 129.5 L 1913.5 133 L 1913 131.5 L 1918.5 125 L 1920.5 124 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2082.5 124 L 2084 127.5 L 2083 127.5 L 2082.5 124 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2151.5 124 L 2154 126.5 L 2154 179 L 2166 179.5 L 2153 180 L 2153 126.5 L 2151.5 124 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1319.5 125 L 1315.5 130 L 1319.5 125 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1465.5 125 L 1467 125.5 L 1464.5 127 L 1465.5 125 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1599.5 125 L 1601 125.5 L 1599 126 L 1598.5 128 L 1598 126.5 L 1599.5 125 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1945.5 125 L 1946.5 127 L 1945.5 125 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2107.5 125 L 2108 128.5 L 2107 128.5 L 2107.5 125 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1855.5 126 L 1856 180 L 1843 179.5 L 1855 179 L 1855.5 126 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1987.5 126 L 1988 141 L 2014 141.5 L 1988.5 142 L 1987 140.5 L 1987.5 126 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1462.5 127 L 1461.5 129 L 1462.5 127 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1536.5 127 L 1538 130.5 L 1537 130.5 L 1536.5 127 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1601.5 127 L 1603 130.5 L 1602 130.5 L 1601.5 127 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1749.5 127 L 1750 129 L 1747 130.5 L 1745.5 133 L 1746 131.5 L 1749.5 127 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2032.5 127 L 2033 135.5 L 2032 135.5 L 2032.5 127 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2121.5 127 L 2121 128.5 L 2120.5 131 L 2120 128.5 L 2121.5 127 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1532.5 128 L 1533 129.5 L 1531.5 132 L 1531 130.5 L 1532.5 128 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1948.5 128 Q 1951.8 129.8 1952 134.5 L 1951 134.5 L 1948.5 128 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2055.5 128 L 2056 129.5 L 2054.5 132 L 2054 130.5 L 2055.5 128 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2067.5 128 L 2068 129.5 L 2066.5 132 L 2066 130.5 L 2067.5 128 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1549.5 129 L 1551 132.5 L 1550 132.5 L 1549.5 129 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1597.5 129 L 1598 130.5 L 1596.5 133 L 1596 131.5 L 1597.5 129 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1614.5 129 L 1616 132.5 L 1615 132.5 L 1614.5 129 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1735.5 129 L 1734.5 131 L 1735.5 129 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2019.5 129 L 2020 136.5 L 2016.5 141 L 2018 138.5 L 2019.5 129 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2072.5 129 L 2074 132.5 L 2073 132.5 L 2072.5 129 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2084.5 129 L 2087 134.5 L 2086 134.5 L 2084.5 129 Z "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1460.5 130 L 1460 131.5 L 1458.5 136 L 1458 133.5 L 1460.5 130 Z "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1519.5 130 L 1520 131.5 L 1518.5 134 L 1518 132.5 L 1519.5 130 Z "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1964.5 130 L 1965 132.5 L 1964 132.5 L 1964.5 130 Z "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1365.5 131 L 1366 133.5 L 1365 133.5 L 1365.5 131 Z "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1445.5 131 L 1446 133.5 L 1445 133.5 L 1445.5 131 Z "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1584.5 131 L 1585 132.5 L 1583.5 135 L 1583 133.5 L 1584.5 131 Z "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1899.5 131 L 1900 134.5 L 1899 134.5 L 1899.5 131 Z "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1538.5 132 L 1540 135.5 L 1539 135.5 L 1538.5 132 Z "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1603.5 132 L 1605 135.5 L 1604 135.5 L 1603.5 132 Z "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1733.5 132 L 1733 133.5 L 1731.5 136 L 1732 134.5 L 1733.5 132 Z "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1352.5 133 L 1353 135.5 L 1352 135.5 L 1352.5 133 Z "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1530.5 133 L 1531 134.5 L 1529.5 137 L 1529 135.5 L 1530.5 133 Z "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2065.5 133 L 2066 134.5 L 2064.5 137 L 2064 135.5 L 2065.5 133 Z "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1551.5 134 L 1553 137.5 L 1552 137.5 L 1551.5 134 Z "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1595.5 134 L 1596 135.5 L 1594.5 138 L 1594 136.5 L 1595.5 134 Z "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1616.5 134 L 1619 139.5 L 1618 139.5 L 1616.5 134 Z "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1744.5 134 L 1744 135.5 L 1742.5 138 L 1743 136.5 L 1744.5 134 Z "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2074.5 134 L 2076 137.5 L 2075 137.5 L 2074.5 134 Z "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1965.5 135 L 1966 139.5 L 1965 139.5 L 1965.5 135 Z "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2052.5 135 L 2053 136.5 L 2051.5 139 L 2051 137.5 L 2052.5 135 Z "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1299.5 136 L 1300 143.5 L 1299 143.5 L 1299.5 136 Z "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1366.5 136 L 1367 156.5 L 1366 156.5 L 1366.5 136 Z "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1444.5 136 L 1445 140.5 L 1444 140.5 L 1444.5 136 Z "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1952.5 136 L 1953 140.5 L 1952 140.5 L 1952.5 136 Z "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2087.5 136 L 2089 139.5 L 2088 139.5 L 2087.5 136 Z "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1312.5 137 L 1313 143.5 L 1312 143.5 L 1312.5 137 Z "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1457.5 137 L 1458 140.5 L 1457 140.5 L 1457.5 137 Z "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1516.5 137 L 1517 138.5 L 1515.5 141 L 1515 139.5 L 1516.5 137 Z "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1540.5 137 L 1542 140.5 L 1541 140.5 L 1540.5 137 Z "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1605.5 137 L 1607 140.5 L 1606 140.5 L 1605.5 137 Z "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1730.5 137 L 1730 138.5 L 1728.5 141 L 1729 139.5 L 1730.5 137 Z "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1353.5 138 L 1354 145.5 L 1353 145.5 L 1353.5 138 Z "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1581.5 138 L 1582 139.5 L 1580.5 142 L 1580 140.5 L 1581.5 138 Z "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1898.5 138 L 1899 155.5 L 1898 155.5 L 1898.5 138 Z "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2031.5 138 L 2032 139.5 L 2025.5 147 L 2023 146.5 L 2030 141.5 L 2031.5 138 Z "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2063.5 138 L 2064 139.5 L 2062.5 142 L 2062 140.5 L 2063.5 138 Z "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1593.5 139 L 1594 140.5 L 1592.5 143 L 1592 141.5 L 1593.5 139 Z "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1741.5 139 L 1740.5 141 L 1741.5 139 Z "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1911.5 139 L 1912 153.5 L 1911 153.5 L 1911.5 139 Z "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2076.5 139 L 2078 142.5 L 2077 142.5 L 2076.5 139 Z "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2107.5 140 L 2108 144.5 L 2107 144.5 L 2107.5 140 Z "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2120.5 140 L 2124 145.5 L 2120 142.5 L 2120.5 140 Z "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1554.5 141 L 1556 144.5 L 1555 144.5 L 1554.5 141 Z "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1619.5 141 L 1621 144.5 L 1620 144.5 L 1619.5 141 Z "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1514.5 142 L 1515 143.5 L 1513.5 146 L 1513 144.5 L 1514.5 142 Z "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1542.5 142 L 1544 145.5 L 1543 145.5 L 1542.5 142 Z "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1607.5 142 L 1609 145.5 L 1608 145.5 L 1607.5 142 Z "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1727.5 142 L 1727 143.5 L 1723.5 149 L 1724 147.5 L 1727.5 142 Z "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1739.5 142 L 1739 143.5 L 1737.5 146 L 1738 144.5 L 1739.5 142 Z "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2049.5 142 L 2050 143.5 L 2048.5 146 L 2048 144.5 L 2049.5 142 Z "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1579.5 143 L 1580 144.5 L 1578.5 147 L 1578 145.5 L 1579.5 143 Z "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2061.5 143 L 2062 144.5 L 2060.5 147 L 2060 145.5 L 2061.5 143 Z "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2090.5 143 L 2092 146.5 L 2091 146.5 L 2090.5 143 Z "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1591.5 144 L 1592 145.5 L 1590.5 148 L 1590 146.5 L 1591.5 144 Z "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2078.5 144 L 2080 147.5 L 2079 147.5 L 2078.5 144 Z "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1749.5 145 L 1750 179 L 1762 179.5 L 1749 180 L 1749.5 145 Z "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2125.5 146 L 2142 146.5 L 2125.5 147 L 2125.5 146 Z "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1353.5 147 L 1354 154.5 L 1353 154.5 L 1353.5 147 Z "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1544.5 147 L 1546 150.5 L 1545 150.5 L 1544.5 147 Z "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1736.5 147 L 1736 148.5 L 1732.5 154 L 1733 152.5 L 1736.5 147 Z "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2027.5 147 L 2031 149.5 L 2029.5 149 L 2027.5 147 Z "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2047.5 147 L 2048 148.5 L 2046.5 151 L 2046 149.5 L 2047.5 147 Z "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2143.5 147 L 2146 148.5 L 2145.5 150 L 2145 148 L 2143.5 147 Z "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1557.5 148 L 1559 151.5 L 1558 151.5 L 1557.5 148 Z "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1622.5 148 L 1624 151.5 L 1623 151.5 L 1622.5 148 Z "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2059.5 148 L 2060 149.5 L 2058.5 152 L 2058 150.5 L 2059.5 148 Z "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2092.5 148 L 2094 151.5 L 2093 151.5 L 2092.5 148 Z "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1299.5 149 L 1300 157.5 L 1299 157.5 L 1299.5 149 Z "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1312.5 149 L 1313 155.5 L 1312 155.5 L 1312.5 149 Z "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1511.5 149 L 1512 150.5 L 1510.5 153 L 1510 151.5 L 1511.5 149 Z "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1589.5 149 L 1590 150.5 L 1588.5 153 L 1588 151.5 L 1589.5 149 Z "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2080.5 149 L 2082 152.5 L 2081 152.5 L 2080.5 149 Z "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1523.5 150 L 1524 151.5 L 1522.5 154 L 1522 152.5 L 1523.5 150 Z "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1576.5 150 L 1577 151.5 L 1575.5 154 L 1575 152.5 L 1576.5 150 Z "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1722.5 150 L 1722 151.5 L 1720.5 154 L 1721 152.5 L 1722.5 150 Z "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1388.5 151 L 1389 180 L 1376 179.5 L 1388 179 L 1388.5 151 Z "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1422.5 151 L 1423 179 L 1435 179.5 L 1422 180 L 1422.5 151 Z "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1785.5 151 L 1786 180 L 1773 179.5 L 1785 179 L 1785.5 151 Z "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1819.5 151 L 1820 179 L 1832 179.5 L 1819 180 L 1819.5 151 Z "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1987 151 L 2015.5 151 L 2020 154.5 L 2019.5 156 L 2017.5 153 L 2015.5 152 L 1988 152 L 1987.5 167 L 1987 151 Z "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2031.5 151 L 2033 153.5 L 2032 153.5 L 2031.5 151 Z "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2110.5 151 L 2113.5 155 L 2110.5 151 Z "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1952.5 152 L 1953 156.5 L 1952 156.5 L 1952.5 152 Z "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1457.5 153 L 1458 157.5 L 1457 157.5 L 1457.5 153 Z "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1559.5 153 L 1561 156.5 L 1560 156.5 L 1559.5 153 Z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1624.5 153 L 1626 156.5 L 1625 156.5 L 1624.5 153 Z "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1965.5 153 L 1966 157.5 L 1965 157.5 L 1965.5 153 Z "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1444.5 154 L 1445 158.5 L 1444 158.5 L 1444.5 154 Z "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1509.5 154 L 1510 155.5 L 1507.5 160 L 1507 158.5 L 1509.5 154 Z "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1587.5 154 L 1588 155.5 L 1586.5 158 L 1586 156.5 L 1587.5 154 Z "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2044.5 154 L 2045 155.5 L 2043.5 158 L 2043 156.5 L 2044.5 154 Z "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2145.5 154 L 2146 155.5 L 2121.5 180 L 2092.5 180 L 2091 177.5 L 2092 177.5 L 2092.5 179 L 2105.5 179 L 2116 169.5 L 2107.5 179 L 2121.5 179 L 2145 155.5 L 2145.5 154 Z "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1612.5 155 L 1614 158.5 L 1613 158.5 L 1612.5 155 Z "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1719.5 155 L 1719 156.5 L 1717.5 159 L 1718 157.5 L 1719.5 155 Z "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1731.5 155 L 1731 156.5 L 1729.5 159 L 1730 157.5 L 1731.5 155 Z "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2095.5 155 L 2097 158.5 L 2096 158.5 L 2095.5 155 Z "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2033.5 156 L 2034 166.5 L 2033 166.5 L 2033.5 156 Z "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2117.5 156 L 2122 156.5 L 2117.5 157 L 2117.5 156 Z "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1352.5 157 L 1353 159.5 L 1352 159.5 L 1352.5 157 Z "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1573.5 157 L 1574 158.5 L 1572.5 161 L 1572 159.5 L 1573.5 157 Z "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1912.5 157 L 1913 159.5 L 1912 159.5 L 1912.5 157 Z "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2020.5 157 L 2021 163.5 L 2020 163.5 L 2020.5 157 Z "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2129.5 157 L 2128.5 159 L 2129.5 157 Z "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1951.5 158 L 1952 160.5 L 1946.5 168 L 1940.5 170 L 1940.5 169 Q 1946.4 168.4 1949 164.5 L 1951.5 158 Z "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1365.5 159 L 1366 161.5 L 1365 161.5 L 1365.5 159 Z "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1458.5 159 L 1461 163.5 L 1459 162.5 L 1458.5 159 Z "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1899.5 159 L 1900 161.5 L 1899 161.5 L 1899.5 159 Z "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2042.5 159 L 2043 160.5 L 2040.5 165 L 2040 163.5 L 2042.5 159 Z "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2126.5 159 L 2117.5 169 L 2126.5 159 Z "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1300.5 160 L 1301 162.5 L 1300 162.5 L 1300.5 160 Z "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1445.5 160 L 1446 162.5 L 1445 162.5 L 1445.5 160 Z "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1562.5 160 L 1564 163.5 L 1563 163.5 L 1562.5 160 Z "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1614.5 160 L 1616 163.5 L 1615 163.5 L 1614.5 160 Z "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1627.5 160 L 1629 163.5 L 1628 163.5 L 1627.5 160 Z "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1716.5 160 L 1716 161.5 L 1714.5 164 L 1715 162.5 L 1716.5 160 Z "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1728.5 160 L 1727.5 162 L 1728.5 160 Z "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1964.5 160 L 1965 162.5 L 1964 162.5 L 1964.5 160 Z "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1314.5 161 L 1316 163.5 L 1314 162.5 L 1314.5 161 Z "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1351.5 161 L 1352 162.5 L 1350 163.5 L 1351.5 161 Z "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1506.5 161 L 1507 162.5 L 1505.5 165 L 1505 163.5 L 1506.5 161 Z "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1571.5 162 L 1572 163.5 L 1569.5 168 L 1569 166.5 L 1571.5 162 Z "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2098.5 162 L 2100 165.5 L 2099 165.5 L 2098.5 162 Z "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1726.5 163 L 1726 164.5 L 1724.5 167 L 1725 165.5 L 1726.5 163 Z "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1914.5 163 L 1921 168.5 L 1919.5 169 L 1916 167 L 1914.5 163 Z "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1301.5 164 L 1306 171.5 L 1303 169.5 L 1301.5 164 Z "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1446.5 164 Q 1448.9 171.6 1455 175.5 L 1448 169.5 L 1446.5 164 Z "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1316.5 165 L 1317.5 167 L 1316.5 165 Z "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1349.5 165 L 1348.5 167 L 1349.5 165 Z "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1461.5 165 L 1469 168.5 L 1466.5 169 L 1461.5 166 L 1461.5 165 Z "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1551.5 165 L 1553 168.5 L 1552 168.5 L 1551.5 165 Z "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1616.5 165 L 1618 168.5 L 1617 168.5 L 1616.5 165 Z "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2019.5 165 L 2020 166.5 L 2017 168.5 L 2019.5 165 Z "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2086.5 165 L 2088 168.5 L 2087 168.5 L 2086.5 165 Z "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1363.5 166 L 1364 167.5 L 1359.5 174 L 1360 172.5 L 1363.5 166 Z "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1517.5 166 L 1518 167.5 L 1516.5 170 L 1516 168.5 L 1517.5 166 Z "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1901.5 166 L 1903 168.5 L 1901 167.5 L 1901.5 166 Z "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2039.5 166 L 2040 167.5 L 2038.5 170 L 2038 168.5 L 2039.5 166 Z "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1319.5 167 L 1325 169.5 L 1322.5 170 L 1319.5 167 Z "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1346.5 167 L 1345.5 169 L 1344 168.5 L 1346.5 167 Z "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1565.5 167 L 1567.5 171 L 1568.5 169 L 1569 170.5 L 1567.5 173 L 1565.5 167 Z "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1582.5 167 L 1583 168.5 L 1581.5 171 L 1581 169.5 L 1582.5 167 Z "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1630.5 167 L 1632 170.5 L 1631 170.5 L 1630.5 167 Z "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2100.5 167 L 2102 170.5 L 2101 170.5 L 2100.5 167 Z "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1503.5 168 L 1504 169.5 L 1502.5 172 L 1502 170.5 L 1503.5 168 Z "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1723.5 168 L 1723 169.5 L 1719.5 175 L 1720 173.5 L 1723.5 168 Z "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1988.5 168 L 1989.5 169 L 2015 169.5 L 1989.5 170 L 1988.5 168 Z "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1340.5 169 L 1343 169.5 L 1340.5 170 L 1340.5 169 Z "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1472.5 169 L 1499.5 169 Q 1500.6 169.1 1500 174.5 L 1501 174.5 L 1501.5 173 L 1502 174.5 L 1500 179 L 1511.5 179 L 1513 177.5 L 1513.5 176 L 1514 177.5 L 1513 180 L 1465 179.5 L 1499 179 L 1499 170.5 L 1498.5 170 L 1472.5 170 L 1472.5 169 Z "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1922.5 169 L 1925 169.5 L 1922.5 170 L 1922.5 169 Z "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1961.5 169 L 1961 170.5 L 1957.5 175 L 1960 171.5 L 1961.5 169 Z "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2032.5 169 L 2033 171.5 L 2027.5 178 L 2031 173.5 L 2032.5 169 Z "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1553.5 170 L 1555 173.5 L 1554 173.5 L 1553.5 170 Z "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1618.5 170 L 1620 173.5 L 1619 173.5 L 1618.5 170 Z "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1903.5 170 L 1908.5 176 L 1903.5 170 Z "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2088.5 170 L 2090 173.5 L 2089 173.5 L 2088.5 170 Z "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1515.5 171 L 1516 172.5 L 1514.5 175 L 1514 173.5 L 1515.5 171 Z "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1580.5 172 L 1581 173.5 L 1579.5 176 L 1579 174.5 L 1580.5 172 Z "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1632.5 172 L 1634 175.5 L 1633 175.5 L 1632.5 172 Z "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2036.5 173 L 2037 174.5 L 2035.5 177 L 2035 175.5 L 2036.5 173 Z "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1308.5 174 L 1314 177.5 L 1312.5 178 L 1308.5 174 Z "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1357.5 174 L 1355.5 177 L 1352.5 178 L 1352.5 177 L 1357.5 174 Z "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1700.5 174 L 1703 178.5 L 1701 177.5 L 1700.5 174 Z "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2103.5 174 L 2105 177.5 L 2104 177.5 L 2103.5 174 Z "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1555.5 175 L 1557 179 L 1577.5 179 L 1578 177.5 L 1579 177.5 L 1577.5 180 L 1557.5 180 L 1556 178.5 L 1555.5 175 Z "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1620.5 175 L 1622 179 L 1636 179.5 L 1622.5 180 Q 1618.8 178.2 1620.5 175 Z "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1955.5 175 L 1954.5 177 L 1951.5 178 L 1951.5 177 L 1955.5 175 Z "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1718.5 176 L 1716.5 179 L 1718.5 176 Z "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1910.5 176 L 1913 177.5 L 1911.5 178 L 1910.5 176 Z "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1458.5 177 L 1463 178.5 L 1460.5 179 L 1458.5 177 Z "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1977.5 177 L 1980 178.5 L 1978.5 179 L 1977.5 177 Z "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 2034.5 178 L 2035.5 179 L 2048 179.5 L 2034 180 L 2034.5 178 Z "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1318.5 179 L 1322 179.5 L 1318.5 180 L 1318.5 179 Z "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1344.5 179 L 1348 179.5 L 1344.5 180 L 1344.5 179 Z "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1918.5 179 L 1921 179.5 L 1918.5 180 L 1918.5 179 Z "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1943.5 179 L 1947 179.5 L 1943.5 180 L 1943.5 179 Z "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1981.5 179 L 2023 179.5 L 1981.5 180 L 1981.5 179 Z "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1327.5 180 L 1339 180.5 L 1327.5 181 L 1327.5 180 Z "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1707.5 180 L 1711 180.5 L 1707.5 181 L 1707.5 180 Z "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1926.5 180 L 1939 180.5 L 1926.5 181 L 1926.5 180 Z "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1586.5 226 Q 1598 224 1601 230.5 L 1602 232.5 L 1600 231.5 L 1597.5 228 Q 1594 225.5 1586.5 227 L 1582 230.5 L 1579.5 236 L 1579 234.5 L 1584.5 227 L 1586.5 226 Z "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1421.5 227 L 1421 228.5 L 1418.5 233 L 1419 231.5 L 1421.5 227 Z "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1429.5 227 L 1433 227.5 Q 1427.4 227.4 1426 231.5 L 1425.5 234 L 1425 231.5 L 1429.5 227 Z "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1476.5 227 L 1480 228.5 L 1478.5 228 Q 1475.5 228.5 1476.5 227 Z "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1499.5 227 L 1502 227.5 L 1498.5 229 L 1499.5 227 Z "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1545.5 227 L 1548.5 227 L 1553 231.5 L 1552.5 236 Q 1552.9 229.6 1548.5 228 Q 1544.5 228.8 1545.5 227 Z "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1296.5 228 L 1294 231.5 L 1293.5 233 L 1293 231.5 L 1296.5 228 Z "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1342.5 228 L 1349 232.5 L 1351 238.5 L 1350 238.5 Q 1349.4 232.6 1345.5 230 Q 1341.8 229.8 1342.5 228 Z "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1354.5 229 L 1358 234.5 L 1356 233.5 L 1354.5 229 Z "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1368.5 229 L 1375 240.5 L 1373 239.5 L 1368.5 229 Z "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1481.5 230 L 1484 232.5 L 1484 293 L 1471 292.5 L 1483 292 L 1483 232.5 L 1481.5 230 Z "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1495.5 231 L 1495 232.5 L 1495 291.5 L 1495.5 292 L 1506.5 292 L 1506.5 293 L 1494.5 293 L 1494 292.5 L 1494 232.5 L 1495.5 231 Z "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1602.5 234 L 1605 239.5 L 1604 239.5 L 1602.5 234 Z "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1306.5 237 L 1306 238.5 L 1306 259 L 1331.5 259 L 1331.5 260 L 1305 260 L 1305 238.5 L 1306.5 237 Z "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1331.5 237 L 1334 237.5 L 1331.5 238 L 1331.5 237 Z "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1469.5 237 L 1470.5 239 L 1469.5 237 Z "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1508.5 237 L 1507.5 239 L 1508.5 237 Z "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1578.5 237 L 1579 238.5 L 1576.5 243 L 1576 241.5 L 1578.5 237 Z "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1335.5 238 L 1337.5 241 L 1335.5 238 Z "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1359.5 238 L 1364 245.5 L 1362 244.5 L 1359.5 238 Z "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1590.5 238 L 1590 239.5 L 1589.5 241 L 1589 239.5 L 1590.5 238 Z "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1437.5 239 L 1438 293 L 1425 292.5 L 1437 292 L 1437.5 239 Z "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1540.5 239 L 1541 292 L 1553 292.5 L 1540 293 L 1540.5 239 Z "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1592.5 239 L 1594 242.5 L 1593 242.5 L 1592.5 239 Z "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1351.5 240 L 1352 246.5 L 1351 246.5 L 1351.5 240 Z "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1400.5 241 L 1400 242.5 L 1389 266 L 1386 264.5 L 1380 252.5 L 1382 253.5 L 1387.5 265 L 1400.5 241 Z "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1605.5 241 L 1607 244.5 L 1606 244.5 L 1605.5 241 Z "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1338.5 242 L 1339 246.5 L 1338 246.5 L 1338.5 242 Z "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1413.5 242 L 1413 243.5 L 1407.5 254 L 1408 252.5 L 1413.5 242 Z "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1588.5 242 L 1589 243.5 L 1587.5 246 L 1587 244.5 L 1588.5 242 Z "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1575.5 244 L 1576 245.5 L 1574.5 248 L 1574 246.5 L 1575.5 244 Z "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1594.5 244 L 1596 247.5 L 1595 247.5 L 1594.5 244 Z "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1607.5 246 L 1610 251.5 L 1609 251.5 L 1607.5 246 Z "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1586.5 247 L 1587 248.5 L 1585.5 251 L 1585 249.5 L 1586.5 247 Z "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1351.5 249 L 1352 255.5 L 1351 255.5 L 1351.5 249 Z "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1365.5 249 L 1369 254.5 L 1367 253.5 L 1365.5 249 Z "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1573.5 249 L 1574 250.5 L 1571.5 255 L 1571 253.5 L 1573.5 249 Z "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1596.5 249 L 1598 252.5 L 1597 252.5 L 1596.5 249 Z "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1338.5 250 L 1339 253.5 L 1338 253.5 L 1338.5 250 Z "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1584.5 252 L 1585 253.5 L 1583.5 256 L 1583 254.5 L 1584.5 252 Z "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1610.5 253 L 1612 256.5 L 1611 256.5 L 1610.5 253 Z "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1598.5 254 L 1600 257.5 L 1599 257.5 L 1598.5 254 Z "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1570.5 256 L 1571 257.5 L 1569.5 260 L 1569 258.5 L 1570.5 256 Z "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1582.5 257 L 1583 258.5 L 1581.5 261 L 1581 259.5 L 1582.5 257 Z "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1612.5 258 L 1615 263.5 L 1614 263.5 L 1612.5 258 Z "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1600.5 259 L 1602 262.5 L 1601 262.5 L 1600.5 259 Z "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1371.5 260 L 1375 265.5 L 1373 264.5 L 1371.5 260 Z "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1349.5 261 L 1350 262.5 Q 1347.6 267.6 1341.5 269 L 1341.5 268 L 1349 262.5 L 1349.5 261 Z "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1568.5 261 L 1569 262.5 L 1566.5 267 L 1566 265.5 L 1568.5 261 Z "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1580.5 262 L 1581 263.5 L 1579.5 266 L 1579 264.5 L 1580.5 262 Z "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1402.5 263 L 1402 264.5 L 1396.5 275 L 1397 273.5 L 1402.5 263 Z "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1615.5 265 L 1617 268.5 L 1616 268.5 L 1615.5 265 Z "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1565.5 268 L 1566 269.5 L 1564.5 272 L 1564 270.5 L 1565.5 268 Z "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1305 269 L 1339 269.5 L 1306 270 L 1306 293 L 1293.5 293 L 1293.5 292 L 1305 292 L 1305 269 Z "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1376.5 269 L 1381 276.5 L 1379 275.5 L 1376.5 269 Z "
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1617.5 270 L 1620 275.5 L 1619 275.5 L 1617.5 270 Z "
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1563.5 273 L 1564 274.5 L 1561.5 279 L 1561 277.5 L 1563.5 273 Z "
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1620.5 277 L 1622 280.5 L 1621 280.5 L 1620.5 277 Z "
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1560.5 280 L 1561 281.5 L 1559.5 284 L 1559 282.5 L 1560.5 280 Z "
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1573.5 280 L 1574 281.5 L 1572.5 284 L 1572 282.5 L 1573.5 280 Z "
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1622.5 282 L 1625 287.5 L 1624 287.5 L 1622.5 282 Z "
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1378.5 283 L 1378 284.5 L 1375.5 289 L 1376 287.5 L 1378.5 283 Z "
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1391.5 284 L 1391 285.5 L 1388 293 L 1373 292.5 L 1386.5 292 L 1388 290.5 L 1391.5 284 Z "
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1558.5 285 L 1559 286.5 L 1556.5 291 L 1556 289.5 L 1558.5 285 Z "
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1625.5 289 L 1627 293 L 1613 292.5 L 1626 291.5 L 1625.5 289 Z "
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,96,96)",
    stroke: "rgb(96,96,96)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 1569.5 290 L 1570 291.5 L 1568.5 293 L 1555.5 293 L 1555.5 292 L 1568.5 292 L 1569.5 290 Z "
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 130 0.5 L 117.5 2 L 101.5 6 L 74.5 18 Q 50.2 31.7 33 52.5 Q 19.8 68.3 11 88.5 L 6 101.5 L 2 117.5 L 0.5 130 L 0 0 Z "
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 163.5 0 L 437 0.5 Q 429.6 2.1 426 7.5 L 370.5 98 L 368 96.5 L 369 1 L 345.5 1 L 345 1.5 L 345 111.5 Q 346.5 120 352.5 124 Q 358.3 127.3 368.5 126 Q 376.1 124.5 380 119.5 L 437.5 27 L 439 28.5 L 439 108.5 L 438 109.5 L 438 125 L 461.5 125 L 462 124.5 L 462 13.5 Q 460.1 5.8 454.5 2 L 450 0.5 L 1257.5 0 L 1257.5 1 L 1253 4.5 L 1227 67 L 1240.5 67 L 1241 64.5 L 1247 50 L 1277.5 50 L 1279 51.5 L 1285.5 67 L 1299 66.5 L 1275 8.5 L 1269.5 1 L 1268 0.5 L 1301 0 L 1301 66.5 L 1301.5 67 L 1314 67 L 1314 38 L 1347 38 L 1347 67 L 1360 67 L 1360 0 L 1392.5 0 L 1392.5 1 L 1388 4.5 L 1362 67 L 1375.5 67 L 1376 65.5 L 1382 50 L 1413.5 50 L 1414 52.5 L 1420 67 L 1440.5 67 L 1442 65.5 L 1462 13 Q 1464.7 11.9 1464 14.5 L 1485 67 L 1498.5 67 L 1499 65.5 L 1474 5.5 L 1470.5 1 L 1469 0.5 L 1501 0 L 1501 60.5 L 1504.5 66 Q 1508.3 68.7 1516.5 67 L 1522 61.5 L 1550.5 15 L 1551 67 L 1563.5 67 L 1564 66.5 L 1564 6.5 L 1559 0.5 L 1568 0 L 1568 11 L 1594 11 L 1594 66.5 L 1594.5 67 L 1607 67 L 1607 11 L 1632 11 L 1632 0 L 1636 0 L 1636 59.5 L 1639.5 66 Q 1643.3 68.7 1651.5 67 L 1656 63.5 L 1685.5 15 L 1687 16.5 L 1687 24.5 L 1686 25.5 L 1686 67 L 1698.5 67 L 1699 66.5 L 1699 6.5 L 1697 2 L 1694 0.5 L 1709 0 L 1709 28.5 L 1715.5 37 L 1720.5 39 L 1753 39 L 1753 67 L 1766 67 L 1766 0.5 L 1766.5 0 L 1785.5 0 L 1785.5 1 Q 1779 0 1778 4.5 L 1777 6.5 L 1777 61.5 L 1780.5 66 L 1783.5 67 L 1830 67 L 1830 56.5 L 1829.5 56 L 1791.5 56 L 1790 54.5 L 1790 38 L 1828.5 38 L 1829 37.5 L 1829 28 L 1790 28 L 1790 12 L 1792.5 11 L 1830 11 L 1830 0 L 1860.5 0 L 1860.5 1 Q 1847.3 0.8 1842 8.5 L 1838 15.5 L 1836 23.5 L 1836 44.5 L 1839 54.5 L 1845.5 62 L 1850.5 65 L 1859.5 67 L 1892 67 L 1892 56 L 1862.5 56 Q 1855.1 54.9 1852 49.5 L 1849 38.5 L 1849 30.5 L 1851 20.5 L 1855.5 14 L 1862.5 11 L 1891 11 L 1891 0 L 1899 0 L 1899 66.5 L 1899.5 67 L 1912 67 L 1912 0 L 1942.5 0 L 1917 26.5 L 1915 33.5 L 1919 42 L 1920.5 42 L 1946.5 67 L 1969.5 67 L 1977.5 50 L 2007.5 50 L 2008 51.5 L 2014 67 L 2043.5 67 L 2067 44.5 Q 2069.7 42.2 2069 36.5 L 2064.5 33 L 2047.5 33 L 2044 30.5 L 2043 28.5 L 2043 16.5 L 2046.5 12 L 2048.5 11 L 2073.5 11 L 2076 14.5 L 2076 67 L 2088.5 67 L 2089 66.5 L 2089 7.5 L 2085.5 2 L 2080 0.5 L 2166 0 L 2165.5 119 L 2162.5 115 L 2160.5 114 L 2116.5 114 L 2111 117.5 L 2107 125.5 L 2107 144.5 Q 2108.5 151.4 2113.5 155 L 2117.5 157 L 2129 157.5 L 2105.5 179 L 2081 119.5 L 2076.5 114 Q 2073 111.5 2065.5 113 L 2059 118.5 L 2034 180 L 2047.5 180 L 2048 178.5 L 2054 163 L 2084.5 163 L 2086 164.5 L 2092.5 180 L 2121.5 180 L 2146 155.5 Q 2147.8 148.8 2144.5 147 L 2141.5 146 L 2124.5 146 L 2121 142.5 L 2120 131.5 L 2123.5 125 L 2126.5 124 L 2150.5 124 L 2153 126.5 L 2153 180 L 2165.5 180 L 2166 180.5 L 2166 414 L 0.5 414 L 0 413.5 L 0 163.5 L 1 163.5 L 2 175.5 L 5 187.5 L 11 204.5 L 17 216.5 Q 29.3 238.7 47.5 255 Q 65.9 272.6 91.5 283 L 110.5 289 L 125.5 292 Q 131 290.5 132.5 293 L 160.5 293 L 189.5 287 Q 206.3 282.3 219.5 274 Q 239.8 262.3 255 245.5 L 276 216.5 L 287 190.5 L 291 175.5 L 291 168.5 L 293 160.5 L 293 131.5 L 288 105.5 L 275 74.5 Q 263 52.5 244.5 37 Q 227.4 21.1 204.5 11 L 191.5 6 L 175.5 2 L 163.5 1 L 163.5 0 Z M 483 1 L 483 125 L 507 125 L 507 71 L 570 71 L 570 125 L 594 125 L 594 125 L 594 1 L 570 1 L 570 51 L 507 51 L 507 1 L 483 1 Z M 628 1 L 620 4 L 614 14 L 614 113 L 617 119 L 624 124 L 633 124 L 634 125 L 698 125 Q 699 122 706 124 L 714 120 L 722 109 L 723 95 L 724 94 L 723 78 L 720 71 Q 715 64 706 62 L 713 59 L 720 50 L 722 40 L 721 23 L 716 11 L 709 4 L 699 1 L 628 1 Z M 755 1 L 748 3 L 743 8 L 740 18 L 740 109 L 742 118 L 750 124 Q 756 122 758 125 L 839 125 L 839 106 L 839 105 L 768 105 L 764 101 L 764 71 L 837 71 L 837 53 L 837 52 L 764 52 L 764 26 L 765 24 L 770 20 L 839 20 L 839 2 L 839 1 L 755 1 Z M 873 1 Q 871 3 867 2 L 861 5 L 853 13 L 850 20 Q 852 25 849 27 L 850 44 L 855 55 Q 861 61 870 64 L 911 76 L 926 82 L 930 88 L 930 99 L 929 101 L 924 105 L 852 105 L 851 106 L 851 125 L 928 125 L 943 122 L 952 112 L 955 100 L 955 86 L 950 72 Q 945 65 937 62 L 891 48 L 879 43 Q 874 40 873 35 L 874 26 L 879 21 L 883 20 L 949 20 L 949 2 L 949 1 L 873 1 Z M 954 1 L 954 20 L 1002 20 L 1002 125 L 1026 125 L 1026 125 L 1026 20 L 1074 20 L 1074 2 L 1074 1 L 954 1 Z M 1322 113 L 1310 117 L 1302 126 L 1299 137 L 1299 158 L 1301 166 L 1306 174 L 1313 178 L 1328 181 L 1348 180 L 1360 174 L 1364 168 L 1367 157 Q 1370 134 1362 123 Q 1358 116 1350 114 L 1345 113 L 1322 113 Z M 1531 113 L 1526 115 L 1501 175 L 1500 169 L 1470 169 L 1461 165 L 1458 159 Q 1459 154 1457 153 L 1457 142 L 1461 130 L 1464 127 L 1472 124 L 1499 124 L 1499 114 L 1464 114 L 1453 119 L 1446 129 L 1444 137 L 1444 159 L 1448 170 Q 1453 178 1466 180 L 1513 180 L 1519 165 L 1520 163 L 1550 163 L 1556 179 L 1558 180 L 1578 180 L 1599 128 Q 1598 125 1601 126 L 1620 177 L 1623 180 L 1636 180 L 1610 118 L 1605 113 Q 1597 112 1594 114 L 1588 122 L 1568 171 L 1544 117 Q 1541 111 1531 113 Z M 1749 113 L 1745 115 Q 1727 139 1714 165 L 1712 165 L 1712 115 L 1712 114 L 1699 114 L 1699 173 L 1701 178 L 1708 181 L 1717 179 L 1723 171 L 1747 131 L 1750 129 L 1750 145 L 1749 146 L 1749 180 L 1762 180 L 1762 120 L 1760 115 L 1757 113 L 1749 113 Z M 1921 113 L 1913 115 L 1908 118 Q 1902 122 1900 129 L 1898 139 L 1898 156 L 1901 168 L 1903 171 L 1912 178 L 1927 181 L 1947 180 L 1958 175 L 1964 166 L 1966 158 L 1966 136 L 1962 124 Q 1958 116 1949 114 L 1945 113 L 1921 113 Z M 1235 114 L 1235 180 L 1236 180 L 1248 180 L 1248 115 L 1248 114 L 1235 114 Z M 1279 114 L 1254 139 L 1251 146 L 1252 151 L 1283 180 L 1299 180 L 1275 158 L 1264 148 L 1264 145 L 1295 115 L 1279 114 Z M 1376 114 L 1376 180 L 1389 180 L 1389 151 L 1422 151 L 1422 180 L 1435 180 L 1435 180 L 1435 114 L 1422 114 L 1422 140 L 1389 140 L 1389 114 L 1376 114 Z M 1631 114 L 1631 124 L 1657 124 L 1657 180 L 1670 180 L 1670 180 L 1670 124 L 1695 124 L 1695 115 L 1695 114 L 1631 114 Z M 1773 114 L 1773 180 L 1786 180 L 1786 151 L 1819 151 L 1819 180 L 1832 180 L 1832 180 L 1832 114 L 1819 114 L 1819 140 L 1786 140 L 1786 114 L 1773 114 Z M 1848 114 L 1843 120 L 1843 180 L 1856 180 L 1856 180 L 1856 126 L 1858 124 L 1896 124 L 1896 115 L 1896 114 L 1848 114 Z M 1980 114 L 1975 120 L 1975 174 L 1977 178 L 1982 180 L 2023 180 L 2028 178 L 2032 174 L 2034 167 Q 2036 155 2031 150 L 2026 147 Q 2032 143 2033 136 L 2032 123 L 2029 117 L 2024 114 L 1980 114 Z M 382 173 L 372 175 L 358 182 L 347 195 L 343 207 L 342 219 L 341 220 L 341 246 L 342 247 L 342 255 L 346 269 L 350 276 Q 356 285 368 289 L 387 293 L 418 293 Q 419 290 426 292 L 439 288 L 447 283 Q 453 277 457 269 L 460 260 L 461 248 L 462 247 L 462 219 Q 459 217 461 211 Q 459 198 453 190 Q 445 177 428 174 Q 423 175 422 173 L 382 173 Z M 1006 173 L 1002 175 L 995 183 L 953 284 L 948 281 L 911 248 L 897 234 Q 896 228 899 226 L 953 175 L 925 174 L 878 221 L 875 228 Q 874 238 879 244 L 931 292 L 974 292 L 985 265 L 986 262 L 1041 262 L 1053 291 L 1054 292 L 1077 292 L 1065 261 L 1030 180 Q 1027 175 1021 173 L 1006 173 Z M 479 174 L 479 275 L 481 285 L 487 290 L 495 292 L 600 292 L 600 273 L 585 273 L 584 273 L 584 174 L 563 174 L 562 175 L 562 273 L 506 273 L 503 272 L 502 270 L 502 175 L 502 174 L 479 174 Z M 621 174 L 615 177 L 610 185 L 610 283 L 613 288 L 619 291 L 624 292 L 704 292 L 704 274 L 704 273 L 636 273 L 632 269 L 632 241 L 702 241 L 702 223 L 702 222 L 632 222 L 632 198 L 633 196 L 638 192 L 703 192 L 703 175 L 703 174 L 621 174 Z M 720 174 L 720 292 L 743 292 L 743 240 L 803 240 L 803 292 L 826 292 L 826 292 L 826 174 L 803 174 L 803 222 L 743 222 L 743 174 L 720 174 Z M 846 174 L 846 292 L 847 292 L 869 292 L 869 175 L 869 174 L 846 174 Z M 1587 226 L 1585 227 L 1579 235 L 1555 293 L 1569 293 L 1575 279 L 1576 276 L 1607 276 L 1613 292 L 1614 293 L 1627 293 L 1601 231 Q 1598 224 1587 226 Z M 1241 227 L 1235 234 L 1235 293 L 1248 293 L 1248 293 L 1248 240 L 1251 237 L 1289 237 L 1289 228 L 1289 227 L 1241 227 Z M 1299 227 L 1297 228 L 1293 232 L 1293 293 L 1306 293 L 1306 270 L 1339 270 L 1345 268 L 1350 263 L 1352 256 Q 1354 240 1349 233 Q 1346 228 1341 227 L 1299 227 Z M 1354 227 L 1381 278 L 1373 293 L 1388 293 L 1422 228 L 1407 227 L 1388 265 L 1368 229 L 1368 227 L 1354 227 Z M 1430 227 L 1425 232 L 1425 293 L 1438 293 L 1438 293 L 1438 238 L 1441 237 L 1469 237 L 1471 240 L 1471 293 L 1484 293 L 1484 293 L 1484 233 L 1479 227 L 1430 227 Z M 1500 227 L 1494 233 L 1494 293 L 1495 293 L 1507 293 L 1507 240 L 1510 237 L 1538 237 L 1539 238 L 1540 239 L 1540 293 L 1553 293 L 1553 293 L 1553 232 L 1549 227 L 1500 227 Z "
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1314 0 L 1347 0 L 1347 27 L 1314 27 L 1314 0 Z "
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1403.5 0 L 1458 0.5 L 1454 3.5 L 1430.5 58 L 1411 10.5 L 1404.5 1 L 1403.5 0 Z "
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1514 0 L 1549 0.5 L 1543 5.5 L 1514.5 52 L 1514 0 Z "
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1649 0 L 1684 0.5 L 1679 4.5 L 1649.5 52 L 1649 0 Z "
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1722 0 L 1753 0 L 1753 28 L 1726.5 28 L 1723 25.5 L 1722 23.5 L 1722 0 Z "
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1959 0 L 1987 0.5 L 1983 3.5 L 1959 61 L 1954.5 59 L 1929 35.5 L 1928 31.5 L 1959 1.5 L 1959 0 Z "
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1998.5 0 L 2045 0.5 Q 2034.8 -0.2 2032 6.5 L 2029 15.5 L 2029 26.5 Q 2031.5 28 2030 33.5 L 2036.5 42 L 2040.5 44 L 2051 44.5 L 2028.5 65 L 2025 59.5 L 2001 2 L 1998.5 0 Z "
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1262.5 12 L 1275 40.5 L 1251 41 L 1262.5 12 Z "
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1398.5 12 L 1410 40.5 L 1386.5 41 L 1387 39.5 L 1395 17.5 L 1398.5 12 Z "
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1992.5 12 L 2004 41 L 1980 40.5 L 1992.5 12 Z "
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 141.5 15 L 171.5 18 L 198.5 26 Q 220.6 35.9 235 53.5 Q 246.1 68.4 252 88.5 L 254 98.5 L 254 106.5 L 255 107.5 L 255 135.5 L 250 163.5 L 244 182.5 L 234 202.5 L 227.5 209 L 224 207.5 Q 220.1 198.4 222 183.5 L 223 182.5 L 225 137.5 L 226 136.5 L 226 99.5 L 222 79.5 Q 219.5 71.5 213.5 67 Q 209.2 63.3 199.5 65 Q 186.8 69.8 180 80.5 L 165 103.5 L 149 136.5 L 129 186.5 Q 123.8 199.3 115.5 209 L 112 207.5 L 111 205.5 L 111 175.5 L 112 174.5 L 113 141.5 L 114 140.5 L 114 102.5 L 113 101.5 L 112 86.5 L 109 76.5 L 100.5 66 L 98.5 65 L 87.5 65 Q 74.3 70.8 66 81.5 Q 45.7 105.7 35 139.5 L 28 168.5 L 27 186.5 L 26 187.5 L 26 202.5 L 28 211.5 L 26 210.5 L 17 190.5 L 12 172.5 L 11 158.5 L 10 157.5 L 10 137.5 L 11 136.5 L 11 127.5 L 13 116.5 L 21 92.5 Q 33.3 65.8 54.5 48 Q 72.1 33.1 95.5 24 L 121.5 17 L 140.5 16 L 141.5 15 Z "
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 641.5 20 L 686.5 20 L 690.5 21 L 695 25.5 Q 698.7 31.3 697 42.5 Q 695.5 49 690.5 52 Q 685.8 50.8 684.5 53 L 638 53 L 638 23.5 L 639 21 L 641.5 20 Z "
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 638 72 L 689.5 72 L 697 77.5 Q 700.3 83.3 699 93.5 Q 697.9 100.9 692.5 104 L 689.5 105 L 640.5 105 L 638 101.5 L 638 72 Z "
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 83.5 83 L 87 84 L 90 93.5 L 90 120.5 L 89 121.5 L 87 168.5 L 86 169.5 L 86 192.5 L 87 193.5 L 87 202.5 L 91 217.5 L 99.5 227 L 109.5 228 L 116.5 225 L 130 211.5 L 144 189.5 Q 164.6 150.1 181 106.5 L 189 90.5 L 194.5 84 Q 198.3 83.3 199 85.5 L 201 89.5 L 202 105.5 L 201 106.5 L 201 132.5 L 200 133.5 L 200 150.5 L 199 151.5 L 199 195.5 L 203 215.5 Q 205.3 222.3 210.5 226 Q 213.5 229 220.5 228 L 229.5 224 L 243 210.5 Q 258.9 188.4 268 159.5 L 275 126.5 L 275.5 101 L 282 126.5 L 283 156.5 L 282 157.5 L 282 165.5 L 280 176.5 L 271 202.5 Q 258.4 227.9 238.5 246 L 215.5 262 L 197.5 270 L 175.5 276 L 147.5 277 L 146.5 278 L 145.5 277 L 135.5 277 L 118.5 274 L 102.5 269 Q 83.5 261.5 71 247.5 Q 58.9 234.1 53 214.5 L 49 195.5 L 49 163.5 L 50 162.5 L 52 143.5 L 61 114.5 L 73 91.5 L 79.5 85 L 83.5 83 Z "
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1331.5 123 L 1342.5 124 L 1351 130.5 L 1353 136.5 L 1353 145.5 L 1354 146.5 L 1353 147.5 L 1352 160.5 L 1347.5 167 Q 1339.9 171.9 1325.5 170 L 1316 164.5 L 1313 157.5 L 1312 144.5 L 1313 143.5 L 1314 132.5 L 1320.5 125 L 1331.5 123 Z "
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1931.5 123 L 1941.5 124 L 1948 127 L 1952 135.5 L 1953 151.5 L 1951 160.5 L 1946.5 167 Q 1939.6 172.1 1925.5 170 Q 1917.4 168.6 1914 162.5 L 1912 156.5 L 1912 136.5 Q 1913.5 129.6 1918.5 126 L 1922.5 124 L 1930.5 124 L 1931.5 123 Z "
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1989.5 124 L 2014.5 124 L 2018 126.5 Q 2020.3 129.7 2019 136.5 L 2015.5 141 L 1988 141 L 1988 125.5 L 1989.5 124 Z "
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1534.5 125 L 1546 154 L 1523.5 154 L 1523 152.5 L 1534.5 125 Z "
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 2069.5 125 L 2082 153.5 L 2058 154 L 2069.5 125 Z "
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1988 152 L 2015.5 152 L 2019 154.5 Q 2021.3 157.7 2020 164.5 L 2016.5 169 L 1989.5 169 L 1988 167.5 L 1988 152 Z "
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 391.5 191 L 411.5 191 Q 413 193.5 418.5 192 Q 427 194.5 432 200.5 L 435 205.5 L 438 216.5 L 439 236.5 L 438 237.5 L 437 253.5 L 435 259.5 L 426.5 270 L 415.5 274 L 395.5 275 L 380.5 272 L 371 264.5 L 368 258.5 L 365 246.5 L 365 218.5 L 370 202.5 L 377.5 195 L 384.5 192 Q 390 193.5 391.5 191 Z "
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1013.5 194 L 1016 196.5 L 1035 246 L 992.5 246 L 992 243.5 L 1011 196.5 L 1013.5 194 Z "
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1307.5 237 L 1330.5 237 L 1334.5 238 L 1338 241.5 L 1339 249.5 L 1338 254.5 L 1335.5 258 L 1333.5 259 L 1306 259 L 1306 238.5 L 1307.5 237 Z "
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1591.5 238 L 1603 267 L 1579 266.5 L 1591.5 238 Z "
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1395.5 0 Q 1405.3 -0.8 1408 5.5 L 1430.5 59 L 1434 53.5 L 1453 6.5 L 1457.5 1 L 1465.5 0 L 1472 3.5 L 1498 66 L 1485.5 66 L 1485 63.5 L 1466 15.5 L 1463.5 12 Q 1461.3 11.3 1462 13.5 L 1440.5 66 L 1420.5 66 L 1420 63.5 L 1413.5 50 L 1382.5 50 L 1381 51.5 L 1376 66 L 1363 65.5 L 1388 5.5 L 1392.5 1 L 1395.5 0 Z M 1398 12 L 1395 16 L 1386 40 L 1386 41 L 1411 41 L 1400 14 L 1398 12 Z "
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1551.5 0 Q 1559.6 -0.6 1562 4.5 L 1564 10.5 L 1564 66 L 1551 66 L 1551 54.5 L 1552 53.5 L 1552 15.5 Q 1550.5 12.5 1549 15.5 L 1525 55.5 L 1516.5 66 L 1508.5 67 L 1503 63.5 L 1502 61.5 L 1502 1 L 1514 1 L 1514 14.5 L 1513 15.5 L 1513 51.5 Q 1515 55 1517 50.5 L 1543 6.5 L 1548.5 1 L 1551.5 0 Z "
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1686.5 0 Q 1694.5 -1 1697 3.5 L 1699 8.5 L 1699 66 L 1687.5 66 L 1687 65.5 L 1687 14.5 L 1685 14 L 1653.5 65 Q 1650.5 68 1643.5 67 L 1639 65 L 1637 60.5 L 1637 1 L 1648.5 1 L 1649 1.5 L 1649 43.5 Q 1646.5 45 1648 50.5 L 1649.5 53 L 1677 8.5 L 1682.5 2 L 1686.5 0 Z "
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1989.5 0 Q 1997.9 -0.9 2001 3.5 L 2027 66 L 2015.5 66 L 2014 64.5 L 2009 50 L 1976.5 50 L 1976 51.5 L 1970 66 L 1946.5 66 L 1917 37.5 L 1916 30.5 L 1918 26.5 L 1943.5 1 L 1958 1.5 L 1928 30.5 L 1928 35.5 L 1935.5 43 L 1958.5 63 L 1980 10.5 L 1986.5 1 L 1989.5 0 Z M 1993 11 Q 1984 24 1980 41 L 2005 41 L 1993 11 Z "
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1301 1 L 1313 1 L 1313 28 L 1348 28 L 1348 1 L 1360 1 L 1360 65.5 L 1359.5 66 L 1348 66 L 1348 38.5 L 1346.5 37 L 1314.5 37 L 1313 38.5 L 1313 66 L 1301 66 L 1301 1 Z "
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1569 1 L 1631.5 1 L 1632 1.5 L 1632 11 L 1606 11 L 1606 65.5 L 1605.5 66 L 1594 66 L 1594 11 L 1569 11 L 1569 1 Z "
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1709 1 L 1721 1 L 1721 21.5 L 1722 25.5 L 1724.5 28 L 1727.5 29 L 1752.5 29 L 1754 27.5 L 1754 1 L 1765.5 1 L 1766 1.5 L 1766 66 L 1754 66 L 1754 39.5 L 1752.5 38 L 1719.5 38 Q 1713.4 36.6 1711 31.5 L 1709 24.5 L 1709 1 Z "
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1783.5 1 L 1828.5 1 L 1829 1.5 L 1829 11 L 1790.5 11 L 1790 12.5 L 1789 13.5 L 1789 28 L 1827.5 28 L 1828 28.5 L 1828 38 L 1789 38 L 1789 53.5 L 1790 56 L 1792.5 57 L 1830 57 L 1830 65.5 L 1829.5 66 L 1782.5 66 L 1778 62.5 L 1777 58.5 L 1777 8.5 L 1781.5 2 L 1783.5 1 Z "
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1857.5 1 L 1889.5 1 L 1890 1.5 L 1890 11 L 1859.5 11 L 1853 15.5 L 1849 24.5 L 1849 43.5 Q 1850.1 50.9 1855.5 54 L 1865.5 57 L 1891 57 L 1891 65.5 L 1890.5 66 L 1856.5 66 Q 1846.1 63.9 1841 56.5 L 1837 46.5 L 1836 29.5 L 1839 14.5 L 1845.5 6 L 1857.5 1 Z "
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1900 1 L 1911.5 1 L 1912 1.5 L 1912 66 L 1900.5 66 L 1900 65.5 L 1900 1 Z "
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 2041.5 1 L 2081.5 1 L 2087 4.5 L 2088 6.5 L 2088 66 L 2076.5 66 L 2076 65.5 L 2076 12.5 L 2074.5 11 L 2046.5 11 Q 2040.2 14.7 2042 26.5 L 2045.5 33 L 2047.5 34 L 2065.5 34 L 2068 35 L 2067 43.5 L 2055.5 55 L 2043.5 66 L 2029.5 66 L 2034.5 60 L 2052 44.5 L 2051.5 43 L 2039.5 43 L 2032 36.5 L 2030 30.5 L 2030 13.5 Q 2031.5 6.6 2036.5 3 L 2041.5 1 Z "
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 625.5 2 L 700.5 2 Q 710.9 4.1 716 11.5 L 721 25.5 L 721 42.5 Q 719 53.5 711.5 59 L 704 61.5 L 711.5 64 L 719 70.5 L 723 80.5 L 723 99.5 Q 720.5 101 722 106.5 L 713.5 119 L 702.5 124 L 626.5 124 Q 620 122.5 617 117.5 L 614 108.5 L 614 17.5 L 616 9.5 L 620.5 4 L 625.5 2 Z M 641 20 L 637 25 L 637 53 L 690 53 L 692 52 L 696 48 L 698 40 L 696 26 L 690 20 L 641 20 Z M 637 71 L 637 101 L 638 104 L 642 106 L 688 106 L 694 104 L 698 100 L 700 90 L 698 78 Q 695 72 688 71 L 637 71 Z "
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 752.5 2 L 837.5 2 L 838 2.5 L 838 20 L 767.5 20 L 764 23.5 L 764 52 L 835.5 52 L 837 53.5 L 837 69.5 L 835.5 71 L 764 71 L 764 102.5 L 766.5 105 L 768.5 106 L 839 106 L 839 123.5 L 838.5 124 L 752.5 124 Q 746 122.5 743 117.5 L 741 111.5 L 741 14.5 Q 742.6 7.5 747.5 4 L 752.5 2 Z "
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 869.5 2 L 947.5 2 L 948 2.5 L 948 20 L 879.5 20 L 874 24.5 L 873 26.5 L 873 37.5 L 878.5 44 L 934.5 62 Q 943.8 64.8 949 71.5 L 954 83.5 L 954 102.5 Q 951.8 115.3 942.5 121 L 932.5 124 L 851 124 L 851 106.5 L 851.5 106 L 922.5 106 L 929 101.5 Q 932.1 97.1 931 88.5 L 925.5 81 L 866.5 62 L 856 54.5 Q 847.4 44.5 850 23.5 L 853 13.5 L 861.5 5 L 869.5 2 Z "
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 955 2 L 1073.5 2 L 1074 2.5 L 1074 18.5 L 1072.5 20 L 1025 20 L 1025 123.5 L 1024.5 124 L 1003 124 L 1003 20 L 955 20 L 955 2 Z "
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1326.5 113 L 1339.5 113 L 1350.5 115 Q 1357.9 117.6 1362 123.5 L 1366 134.5 L 1366 158.5 Q 1364.2 168.2 1358.5 174 L 1351.5 178 L 1343.5 180 L 1322.5 180 L 1314.5 178 L 1306 172.5 L 1301 163.5 L 1299 144.5 L 1300 143.5 L 1300 133.5 L 1302 127.5 L 1309.5 118 L 1315.5 115 L 1326.5 113 Z M 1326 123 L 1320 125 Q 1313 129 1312 138 L 1312 156 L 1316 166 L 1323 170 L 1332 170 L 1333 171 Q 1336 169 1343 170 L 1349 167 L 1352 163 L 1354 155 Q 1356 139 1351 130 L 1345 124 Q 1337 122 1326 123 Z "
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1533.5 113 Q 1541 113 1544 117.5 L 1567.5 173 L 1588 123.5 L 1594.5 114 L 1601.5 113 L 1609 117.5 L 1635 178.5 L 1622 179 L 1601 125 L 1598 126.5 L 1578 179 L 1557.5 179 L 1557 177.5 L 1551 163 L 1518.5 163 L 1518 165.5 L 1511.5 179 L 1500.5 179 L 1500 177.5 L 1523 122.5 L 1529.5 114 L 1533.5 113 Z M 1535 125 L 1522 153 L 1523 154 L 1547 154 L 1536 127 Q 1537 124 1535 125 Z "
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1750.5 113 Q 1757 113.3 1760 116 L 1762 121.5 L 1762 179 L 1750.5 179 L 1750 178.5 L 1750 127.5 L 1746 130.5 L 1719 175.5 L 1715.5 179 L 1706.5 180 L 1702 177.5 L 1700 173.5 L 1700 114 L 1711.5 114 L 1712 114.5 L 1712 165.5 L 1714 166 L 1734 131.5 L 1745.5 115 L 1750.5 113 Z "
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1925.5 113 L 1938.5 113 L 1949.5 115 Q 1957.4 117.1 1961 123.5 L 1965 133.5 L 1966 152.5 L 1963 166.5 L 1956.5 175 L 1942.5 180 L 1921.5 180 L 1909.5 176 L 1903 169.5 L 1899 158.5 L 1899 135.5 L 1902 125.5 L 1908.5 118 L 1918.5 114 Q 1924 115.5 1925.5 113 Z M 1925 123 L 1919 125 L 1914 130 L 1911 140 L 1912 160 L 1916 167 L 1923 170 L 1931 170 L 1932 171 Q 1935 169 1943 170 L 1947 168 Q 1952 164 1953 157 L 1953 137 L 1951 131 L 1944 124 Q 1936 122 1925 123 Z "
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 2068.5 113 Q 2076 113 2079 117.5 L 2105 178.5 L 2092 179 L 2086 163 L 2054.5 163 L 2053 164.5 L 2048 179 L 2035.5 179 L 2035 177.5 L 2058 122.5 L 2064.5 114 L 2068.5 113 Z M 2070 125 L 2066 131 L 2057 154 L 2082 154 L 2071 127 Q 2072 124 2070 125 Z "
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1376 114 L 1388 114 L 1388 141 L 1423 141 L 1423 114 L 1435 114 L 1435 178.5 L 1434.5 179 L 1423 179 L 1423 151 L 1388 151 L 1388 179 L 1376 179 L 1376 114 Z "
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1466.5 114 L 1497.5 114 L 1498 114.5 L 1498 124 L 1468.5 124 L 1461 128.5 L 1457 137.5 L 1457 157.5 L 1461 166 L 1466.5 169 Q 1471.3 167.7 1472.5 170 L 1499 170 L 1499 178.5 L 1498.5 179 L 1463.5 179 Q 1453.5 177 1449 169.5 L 1445 159.5 L 1444 141.5 L 1447 127.5 L 1452.5 120 L 1466.5 114 Z "
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1632 114 L 1694.5 114 L 1695 114.5 L 1695 124 L 1669 124 L 1669 178.5 L 1668.5 179 L 1657 179 L 1657 124 L 1632 124 L 1632 114 Z "
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1773 114 L 1785 114 L 1785 141 L 1820 141 L 1820 114 L 1832 114 L 1832 178.5 L 1831.5 179 L 1820 179 L 1820 151 L 1785 151 L 1785 179 L 1773 179 L 1773 114 Z "
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1850.5 114 L 1895.5 114 L 1896 114.5 L 1896 122.5 L 1894.5 124 L 1856 124 L 1855 126.5 L 1855 179 L 1843.5 179 L 1843 178.5 L 1843 122.5 L 1844 118.5 L 1847.5 115 L 1850.5 114 Z "
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1981.5 114 L 2020.5 114 L 2029 118.5 Q 2033.8 124.7 2032 137.5 L 2026.5 145 L 2023 146.5 Q 2028.9 146.6 2031 150.5 L 2033 154.5 L 2033 168.5 Q 2031.5 175 2026.5 178 L 2023.5 179 L 1980.5 179 L 1977 176.5 L 1975 171.5 L 1975 122.5 L 1976 118.5 L 1979.5 115 L 1981.5 114 Z M 1988 124 L 1987 127 L 1987 141 L 1989 142 L 2014 142 L 2017 141 L 2020 137 Q 2021 128 2018 125 L 2016 124 L 1988 124 Z M 1987 151 L 1987 167 L 1990 170 L 2015 170 L 2018 169 L 2021 164 L 2020 155 L 2016 151 L 1987 151 Z "
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 2120.5 114 L 2158.5 114 L 2165 118.5 L 2166 121.5 L 2166 179 L 2154.5 179 L 2154 178.5 L 2154 126.5 L 2151.5 124 L 2124.5 124 L 2122 125 L 2120 128.5 L 2120 142.5 L 2125.5 147 L 2142.5 147 L 2145 148 L 2146 153.5 L 2121.5 179 L 2107 178.5 L 2130 157.5 L 2116.5 156 L 2110 150.5 L 2107 139.5 L 2107 129.5 L 2108 124.5 L 2112 117 L 2120.5 114 Z "
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1300.5 227 L 1338.5 227 L 1348 232.5 L 1351 239.5 L 1352 248.5 L 1351 249.5 L 1350 260.5 L 1344.5 267 L 1340.5 269 L 1305 269 L 1305 292 L 1293 292 L 1293 233.5 L 1297.5 228 L 1300.5 227 Z M 1307 237 L 1305 239 L 1305 260 L 1332 260 L 1337 258 L 1339 254 L 1339 243 L 1338 241 L 1334 237 L 1307 237 Z "
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1354 227 L 1366.5 227 L 1368 228.5 L 1387.5 266 Q 1389.8 266.8 1389 264.5 L 1408.5 227 L 1421 227.5 L 1386.5 292 L 1374 291.5 L 1381 279.5 L 1381 276.5 L 1354 227 Z "
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1433.5 227 L 1475.5 227 L 1481 229 L 1483 232.5 L 1483 292 L 1471.5 292 L 1471 291.5 L 1471 238.5 L 1469.5 237 L 1438 237 L 1437 239.5 L 1437 292 L 1425.5 292 L 1425 291.5 L 1425 234.5 L 1429.5 228 L 1433.5 227 Z "
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1502.5 227 L 1544.5 227 L 1548.5 228 L 1552 231.5 L 1553 236.5 L 1553 292 L 1541.5 292 L 1541 291.5 L 1541 239.5 L 1540 237 L 1508.5 237 L 1507 238.5 L 1507 291.5 L 1506.5 292 L 1495 292 L 1495 232.5 L 1497.5 229 L 1502.5 227 Z "
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(97,97,97)",
    stroke: "rgb(97,97,97)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1586.5 227 Q 1597 225 1600 230.5 L 1626 291.5 L 1613 292 L 1606.5 276 L 1575.5 276 L 1574 277.5 L 1569 292 L 1556 291.5 L 1579 236.5 L 1584.5 228 L 1586.5 227 Z M 1591 238 L 1579 267 L 1604 267 L 1593 240 L 1591 238 Z "
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 82.5 458 L 106.5 458 L 110.5 459 Q 119.5 461.4 124 468.5 L 128 480.5 L 128 501.5 L 125 512.5 L 118.5 520 Q 106.6 527.6 84.5 525 L 70.5 520 L 66 515.5 L 61 502.5 L 61 480.5 L 65 468.5 L 71.5 462 L 82.5 458 Z M 87 468 L 81 470 Q 75 474 74 482 L 74 502 L 78 511 L 88 515 Q 104 517 111 511 L 115 502 L 115 482 L 112 474 Q 109 469 103 468 L 87 468 Z "
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 139 458 L 150.5 458 L 151 458.5 L 151 511.5 L 152 514 L 185 514 L 185 458.5 L 185.5 458 L 197 458 L 197 513.5 L 197.5 514 L 206 514 L 206 524 L 144.5 524 L 140 520.5 L 139 518.5 L 139 458 Z "
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 222.5 458 L 263.5 458 L 265 459.5 L 265 467.5 L 263.5 469 L 226.5 469 L 225 470.5 L 225 486 L 263.5 486 L 264 486.5 L 264 494.5 L 262.5 496 L 225 496 L 225 512.5 L 226.5 514 L 264.5 514 L 265 514.5 L 265 524 L 217.5 524 L 214 521.5 L 212 516.5 L 212 466.5 L 215.5 460 L 222.5 458 Z "
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 275 458 L 287 458 L 287 485 L 321 485 L 321 459.5 L 322.5 458 L 332.5 458 L 334 459.5 L 334 523.5 L 333.5 524 L 321 524 L 321 495 L 287 495 L 287 524 L 275 524 L 275 458 Z "
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 347.5 458 L 357.5 458 L 359 459.5 L 359 523.5 L 358.5 524 L 346 524 L 346 459.5 L 347.5 458 Z "
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 391.5 458 L 404.5 458 L 405 460 L 403.5 460 L 375 487.5 L 374 491.5 L 381.5 500 L 405.5 521 L 432 460 Q 435.6 456.9 444.5 458 L 450 462.5 L 476 523.5 L 462 524 L 458 511.5 L 455.5 508 L 424.5 508 L 424 509.5 L 418 524 L 393.5 524 L 364 496.5 L 362 488.5 L 364 484.5 L 389.5 459 L 391.5 458 Z M 439 470 L 428 498 L 429 499 L 452 499 L 442 472 L 439 470 Z "
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 623 458 L 650.5 458 Q 652 460.5 657.5 459 Q 668.2 461.3 673 469.5 L 676 477.5 L 677 495.5 L 676 496.5 L 675 508.5 Q 672.4 515.9 666.5 520 L 656.5 524 L 622 524 L 622 514.5 L 622.5 514 L 651.5 514 Q 658.7 512.2 662 506.5 L 664 496 L 624.5 496 L 624 495.5 L 624 486 L 663.5 486 L 664 484.5 L 662 476.5 L 656.5 471 L 652.5 469 L 623 469 L 623 458 Z "
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 688.5 458 L 698.5 458 L 700 459.5 L 700 523.5 L 699.5 524 L 687 524 L 687 459.5 L 688.5 458 Z "
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 732.5 458 L 745.5 458 L 746 459.5 L 716 487.5 L 715 490.5 Q 716.4 496.6 721.5 499 L 749 523.5 L 734.5 524 L 705 496.5 L 703 489.5 L 705 484.5 L 730.5 459 L 732.5 458 Z "
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 779.5 458 L 805.5 458 L 807 459.5 L 807 467.5 L 805.5 469 L 776.5 469 Q 770.4 470.4 768 475.5 L 766 480.5 L 765 496.5 Q 767.5 498 766 503.5 L 772.5 512 L 777.5 514 L 806.5 514 L 808 515.5 L 808 523.5 L 807.5 524 L 772.5 524 Q 763.1 521.9 758 515.5 L 753 504.5 L 752 487.5 L 755 472.5 L 762.5 463 L 771.5 459 Q 777.7 460.8 779.5 458 Z "
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 826.5 458 L 866.5 458 L 871.5 459 L 875 462.5 L 876 465.5 L 876 524 L 863.5 524 L 863 523.5 L 863 469 L 831.5 469 L 830 470.5 L 830 524 L 817.5 524 L 817 523.5 L 817 466.5 L 820.5 460 L 826.5 458 Z "
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 898.5 458 L 939.5 458 L 941 459.5 L 941 467.5 L 939.5 469 L 902.5 469 L 901 470.5 L 901 486 L 939.5 486 L 940 486.5 L 940 494.5 L 938.5 496 L 901 496 L 901 512.5 L 902.5 514 L 940.5 514 L 941 514.5 L 941 524 L 893.5 524 L 890 522 L 888 515.5 L 888 467.5 L 891.5 460 L 898.5 458 Z "
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 960.5 458 L 993.5 458 Q 994.8 460.2 999.5 459 L 1006 463.5 L 1010 474.5 L 1010 484.5 L 1007 494.5 L 1002.5 499 L 997.5 501 L 963 501 L 963 524 L 951 524 L 951 464.5 L 954.5 460 L 960.5 458 Z M 965 469 L 963 471 L 963 491 L 992 491 L 994 490 L 997 484 L 996 473 L 993 469 L 965 469 Z "
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1014 458 L 1076.5 458 L 1078 459.5 L 1078 467.5 L 1076.5 469 L 1052 469 L 1052 523.5 L 1051.5 524 L 1039 524 L 1039 469 L 1014 469 L 1014 458 Z "
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1084.5 458 L 1095.5 458 L 1096 458.5 L 1096 509.5 L 1098 510 L 1123 467.5 L 1130.5 459 L 1139.5 458 L 1145 462.5 L 1146 465.5 L 1146 524 L 1133 524 L 1133 508.5 L 1134 507.5 L 1134 473.5 L 1132 472.5 L 1100.5 523 Q 1097.5 526 1090.5 525 L 1085 521.5 L 1083 513.5 L 1083 459.5 L 1084.5 458 Z "
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1158 458 L 1194.5 458 Q 1195.8 460.2 1200.5 459 L 1208 464.5 L 1210 468.5 L 1210 482.5 L 1205.5 489 L 1202 490.5 L 1209 494.5 L 1211 498.5 L 1212 509.5 L 1209 518.5 L 1205.5 522 L 1199.5 524 L 1158 524 L 1158 514.5 L 1158.5 514 L 1194.5 514 Q 1199.9 511.4 1199 502.5 L 1195.5 497 L 1193.5 496 L 1159 496 L 1159 486.5 L 1159.5 486 L 1192.5 486 L 1197 482.5 L 1197 471.5 L 1194.5 469 L 1158.5 469 L 1158 468.5 L 1158 458 Z "
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1245.5 458 Q 1256.3 456.2 1259 462.5 L 1285 523.5 L 1272.5 524 L 1264.5 508 L 1233.5 508 L 1233 509.5 L 1226.5 524 L 1214 523.5 L 1238 465.5 L 1243.5 459 L 1245.5 458 Z M 1250 469 L 1247 473 L 1237 499 L 1262 499 L 1250 469 Z "
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1433 458 L 1444.5 458 L 1445 458.5 L 1445 524 L 1433.5 524 L 1433 523.5 L 1433 458 Z "
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1477.5 458 L 1490.5 458 L 1491 459.5 L 1461 488.5 Q 1460.1 495.4 1464.5 497 L 1495 523.5 L 1479.5 524 L 1452 498.5 Q 1447.9 495.6 1449 487.5 L 1454.5 480 L 1477.5 458 Z "
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1519.5 458 L 1543.5 458 L 1547.5 459 Q 1556.5 461.4 1561 468.5 L 1565 480.5 L 1565 501.5 L 1560 515.5 L 1555.5 520 Q 1543.6 527.6 1521.5 525 L 1510.5 522 L 1503 515.5 L 1498 502.5 L 1498 479.5 Q 1500 467.5 1508.5 462 L 1519.5 458 Z M 1524 468 L 1518 470 Q 1513 474 1511 481 L 1511 502 L 1515 511 L 1525 515 Q 1537 517 1545 513 L 1550 508 L 1552 501 L 1552 482 L 1549 474 Q 1546 469 1540 468 L 1524 468 Z "
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1576 458 L 1588 458 L 1588 485 L 1622 485 L 1622 459.5 L 1623.5 458 L 1633.5 458 L 1635 459.5 L 1635 523.5 L 1634.5 524 L 1622 524 L 1622 495 L 1588 495 L 1588 524 L 1576 524 L 1576 458 Z "
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1672.5 458 L 1698.5 458 L 1700 459.5 L 1700 467.5 L 1698.5 469 L 1669.5 469 Q 1663.4 470.4 1661 475.5 L 1659 480.5 L 1658 496.5 Q 1660.5 498 1659 503.5 L 1665.5 512 L 1670.5 514 L 1699.5 514 L 1701 515.5 L 1701 523.5 L 1700.5 524 L 1665.5 524 Q 1656.1 521.9 1651 515.5 L 1646 503.5 L 1645 487.5 L 1648 472.5 L 1655.5 463 L 1664.5 459 Q 1670.8 460.8 1672.5 458 Z "
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1733.5 458 Q 1745.3 456.2 1748 463.5 L 1770 518 Q 1773 519.3 1772 515.5 L 1796.5 460 Q 1800.2 456.7 1808.5 458 L 1814 462.5 L 1839 524 L 1826.5 524 L 1826 522.5 L 1804.5 470 Q 1802.3 469.3 1803 471.5 L 1781.5 524 L 1760.5 524 L 1759 522.5 L 1754 508 L 1721.5 508 L 1721 510.5 L 1714.5 524 L 1702 523.5 L 1725 468.5 L 1731.5 459 L 1733.5 458 Z M 1738 469 L 1725 498 L 1726 499 L 1750 499 L 1740 473 L 1738 469 Z "
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1838.5 458 L 1899.5 458 L 1901 459.5 L 1901 467.5 L 1899.5 469 L 1875 469 L 1875 523.5 L 1874.5 524 L 1863 524 L 1863 469 L 1838.5 469 L 1837 467.5 L 1837 459.5 L 1838.5 458 Z "
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1907 458 L 1918.5 458 L 1919 458.5 L 1919 509.5 L 1920.5 510 L 1947 466.5 L 1953.5 459 L 1962.5 458 L 1968 462.5 L 1969 464.5 L 1969 524 L 1957.5 524 L 1957 523.5 L 1957 472.5 L 1954 474.5 L 1930 514.5 L 1922.5 524 L 1913.5 525 L 1908 520.5 L 1907 518.5 L 1907 458 Z "
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1982 458 L 1994 458 L 1994 485 L 2028 485 L 2028 459.5 L 2029.5 458 L 2039.5 458 L 2041 459.5 L 2041 523.5 L 2040.5 524 L 2028 524 L 2028 495 L 1994 495 L 1994 524 L 1982 524 L 1982 458 Z "
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 2062.5 458 L 2105.5 458 L 2106 458.5 L 2106 469 L 2066 469 L 2066 523.5 L 2065.5 524 L 2053 524 L 2053 466.5 L 2056.5 460 L 2062.5 458 Z "
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 540.5 473 L 550.5 473 L 560 479.5 Q 565.3 484.2 564 495.5 Q 561.9 502.9 556.5 507 Q 551.7 511.7 540.5 510 Q 533.8 507.8 530 502.5 Q 525.3 497.7 527 486.5 Q 529.3 479.8 534.5 476 L 540.5 473 Z "
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,244,237)",
    stroke: "rgb(252,244,237)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1349.5 473 L 1359.5 473 Q 1366.3 475.3 1370 480.5 Q 1374.7 485.3 1373 496.5 Q 1370.8 503.3 1365.5 507 Q 1360.7 511.7 1349.5 510 Q 1342.8 507.8 1339 502.5 Q 1334.8 497.7 1336 487.5 L 1342.5 477 L 1349.5 473 Z "
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 130.5 0 L 146 0.5 L 130.5 1 L 129.5 2 L 117.5 3 L 91.5 11 Q 59.3 24.3 38 48.5 Q 16.5 71.5 6 105.5 L 1 130.5 L 1 162.5 L 6 187.5 L 11 201.5 Q 23.8 231.2 45.5 252 Q 64.1 269.9 89.5 281 L 114.5 289 L 131 291.5 L 125.5 292 Q 69 281.5 38 245.5 Q 15.7 222.3 5 187.5 L 0 162.5 L 0 130.5 L 6 101.5 L 18 74.5 Q 31.7 50.2 52.5 33 Q 68.3 19.8 88.5 11 L 101.5 6 L 130.5 0 Z "
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 147.5 0 L 162.5 0 L 163.5 1 L 175.5 2 L 191.5 6 L 204.5 11 Q 237.8 26.2 260 52.5 Q 278.5 74.5 288 105.5 L 293 131.5 L 293 160.5 L 291.5 168 L 291 161.5 L 292 160.5 L 292 131.5 L 291 130.5 L 290 117.5 L 286 102.5 L 275 76.5 Q 262.9 55.1 245.5 39 Q 226.7 21.8 201.5 11 L 175.5 3 L 163.5 2 L 162.5 1 L 147.5 1 L 147.5 0 Z "
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 437.5 0 L 443 0.5 Q 429.7 1.2 425 10.5 L 370.5 99 Q 367.2 100.1 368 97.5 L 367 96.5 L 367 76.5 L 368 76.5 L 368 96.5 L 369.5 98 L 372 96.5 L 420 16.5 L 429.5 4 L 437.5 0 Z "
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 444.5 0 Q 455.4 -0.4 459 6.5 L 461 11.5 L 460 11.5 L 457 5 L 452.5 2 L 444.5 1 L 444.5 0 Z "
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 1258.5 0 Q 1269 -2 1272 3.5 L 1299 66.5 L 1285.5 67 L 1280 54.5 L 1281 54.5 L 1285 66 L 1296.5 66 L 1297 63.5 L 1275 11.5 L 1268.5 2 Q 1265.3 -0.3 1258.5 1 L 1254 4.5 L 1228 65.5 L 1239.5 66 L 1241 65.5 L 1240.5 67 L 1227 67 L 1251 7.5 L 1256.5 1 L 1258.5 0 Z "
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 345 1 L 369 1 L 369 43.5 L 368 43.5 L 368 2 L 346 2 L 345.5 112 L 345 1 Z "
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 483.5 1 L 507 1 L 507 51 L 569.5 51 L 569.5 52 L 506 52 L 506 2 L 483.5 2 L 483.5 1 Z "
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 570.5 1 L 593.5 1 L 594 1.5 L 594 125 L 570 124.5 L 593 124 L 593 2.5 L 592.5 2 L 570.5 2 L 570.5 1 Z "
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 1262.5 11 Q 1264.8 10.3 1264 12.5 L 1276 40.5 L 1274 39.5 L 1262.5 12 L 1250.5 41 L 1250 38.5 L 1262.5 11 Z "
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 461.5 13 L 462 18.5 L 461 18.5 L 461.5 13 Z "
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 142.5 14 L 171.5 17 L 193.5 23 Q 216 31.5 231 47.5 L 243 63.5 L 253 88.5 L 255 98.5 L 255 106.5 L 256 107.5 L 256 135.5 L 255 136.5 L 255 144.5 L 253 154.5 L 246 180.5 L 236 201.5 L 229.5 209 L 225.5 210 L 223 209 L 221 200.5 L 221 183.5 L 222 182.5 L 222 168.5 L 223 167.5 L 224.5 138 L 225 152.5 L 224 153.5 L 224 167.5 L 223 168.5 L 223 182.5 L 222 183.5 L 222 200.5 L 223 205.5 L 225.5 209 L 227.5 209 L 234 202.5 L 244 182.5 L 252 154.5 L 254 144.5 L 254 136.5 L 255 135.5 L 255 107.5 L 254 106.5 L 254 98.5 L 252 88.5 L 247 74.5 Q 238.4 53.1 221.5 40 L 206.5 30 L 187.5 22 L 165.5 17 L 142.5 15 L 142.5 14 Z "
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 129.5 15 L 141 15.5 L 116.5 18 Q 97.2 22.2 81.5 30 Q 57.8 42.3 41 61.5 Q 23.6 80.6 15 108.5 L 11 127.5 L 10 157.5 L 15 184.5 L 26.5 211 L 27 203.5 L 26 202.5 L 26 187.5 L 27 186.5 L 27 175.5 L 31 153.5 L 40 125.5 L 55 96.5 Q 63.5 82.5 75.5 72 L 87.5 65 L 91.5 65 L 91.5 66 L 87.5 66 L 81.5 69 L 67 81.5 L 52 103.5 L 36 139.5 L 29 168.5 L 28 186.5 L 27 187.5 L 27 202.5 L 28 203.5 L 29 215.5 L 28 215.5 L 19 198.5 L 12 177.5 L 10 166.5 L 10 158.5 L 9 157.5 L 9 137.5 L 10 136.5 L 11 121.5 L 15 104.5 L 26 80.5 Q 38 60.5 55.5 46 Q 71.4 32.4 92.5 24 L 116.5 17 L 128.5 16 L 129.5 15 Z "
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 436.5 27 L 436 28.5 L 386 110.5 L 377.5 122 L 370.5 125 L 370.5 124 Q 377.7 122.2 381 116.5 L 436.5 27 Z "
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 438.5 27 L 440 27.5 L 440 82.5 L 439 82.5 L 439 28.5 L 438.5 27 Z "
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 1247.5 49 L 1278.5 49 L 1279 50.5 L 1280 52.5 L 1279 52.5 L 1277.5 50 L 1247.5 50 L 1247 51.5 L 1243.5 59 L 1243 57.5 L 1247.5 49 Z "
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 1242.5 60 L 1243 61.5 L 1241.5 64 L 1241 62.5 L 1242.5 60 Z "
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 93.5 65 Q 103.3 64.7 106 71.5 L 109 76.5 L 113 92.5 L 113 101.5 L 114 102.5 L 114 140.5 L 113 141.5 L 113 158.5 L 112 159.5 L 112 174.5 L 111 175.5 L 111 205.5 L 113.5 209 Q 117.5 209.5 118 206.5 L 129 186.5 L 149 136.5 L 165 103.5 L 180 80.5 L 191.5 69 Q 195.5 65 203.5 65 L 203.5 66 Q 188.4 68.4 182 79.5 L 163 109.5 L 149 139.5 L 131 184.5 L 122 202.5 L 115.5 210 Q 111.8 210.8 111 208.5 L 110 205.5 L 110 175.5 L 111 174.5 L 112 141.5 L 113 140.5 L 113 102.5 L 112 101.5 L 112 92.5 L 110 82.5 Q 107.4 73.6 101.5 68 Q 99.2 65.3 93.5 66 L 93.5 65 Z "
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 205.5 65 Q 214.6 65.4 218 71.5 L 223 82.5 L 226 99.5 L 226 136.5 L 225 136.5 L 225 99.5 L 224 98.5 L 223 86.5 L 218 73.5 L 211.5 67 L 205.5 66 L 205.5 65 Z "
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 506 70 L 570 70.5 L 507 71 L 507 125 L 483.5 125 L 483.5 124 L 506 124 L 506 70 Z "
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 83.5 82 L 89 85.5 L 91 93.5 L 91 120.5 L 90 121.5 L 88.5 151 L 88 136.5 L 89 135.5 L 89 121.5 L 90 120.5 L 90 93.5 L 87 84 L 83.5 83 L 73 91.5 L 66 103.5 L 56 128.5 L 52 143.5 L 49.5 163 L 49 155.5 L 54 131.5 L 61 111.5 L 72 91.5 L 80.5 83 L 83.5 82 Z "
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 194.5 83 Q 200.3 82.3 201 86.5 L 200.5 89 L 197.5 84 Q 192.8 83.3 192 86.5 L 181 106.5 Q 164.6 150.1 144 189.5 L 130 211.5 L 116.5 225 Q 112.1 229 102.5 228 L 99.5 227 L 92 219.5 L 89 209.5 L 90 209.5 Q 91.7 220.8 99.5 226 L 109.5 227 Q 121.5 222.5 128 212.5 L 140 194.5 L 153 169.5 L 185 95.5 L 189 88.5 L 194.5 83 Z "
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 201.5 90 L 202 95.5 L 201 95.5 L 201.5 90 Z "
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 273.5 95 Q 282.9 111.1 283 136.5 L 282 136.5 L 281 120.5 L 275.5 101 L 274.5 106 L 273.5 95 Z "
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 201.5 106 L 202 132.5 L 201 133.5 L 201 150.5 L 200 151.5 L 200 195.5 L 201 196.5 L 202 209.5 Q 204.1 218.4 209.5 224 Q 212.4 228.1 220.5 227 Q 233.1 222.6 240 212.5 Q 260.1 186.6 269.5 150 L 270 152.5 Q 262.6 179.1 250 200.5 Q 241.7 214.2 229.5 224 L 220.5 228 L 214.5 228 L 206 221.5 L 201 209.5 L 200 196.5 L 199 195.5 L 199 151.5 L 200 150.5 L 200 133.5 L 201 132.5 L 201.5 106 Z "
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 438.5 109 L 439 124 L 462 124.5 L 438 125 L 438.5 109 Z "
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 346.5 113 Q 347.4 119.1 351.5 122 L 357 124.5 L 354.5 125 L 348 119.5 Q 345 117 346.5 113 Z "
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 1235.5 114 L 1236 179 L 1248 179.5 L 1235 180 L 1235.5 114 Z "
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 1278.5 114 L 1280 114.5 L 1254 140.5 L 1252 146.5 L 1254 151.5 L 1269.5 167 L 1282.5 179 L 1296.5 179 L 1295.5 177 L 1264 149.5 L 1263 144.5 L 1265.5 141 L 1294.5 114 L 1284.5 125 L 1264 144.5 L 1264 147.5 L 1274.5 158 L 1299 179.5 L 1282.5 180 L 1252 150.5 L 1251 145.5 L 1254 138.5 L 1278.5 114 Z "
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 274.5 117 L 275 126.5 L 274 126.5 L 274.5 117 Z "
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 358.5 125 L 369 125.5 L 358.5 126 L 358.5 125 Z "
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 273.5 128 L 274 133.5 L 270.5 149 L 270 145.5 L 273.5 128 Z "
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 283.5 138 L 284 156.5 L 283 157.5 L 282 171.5 L 278 187.5 L 266 214.5 Q 253.9 233.4 237.5 248 Q 222.7 260.7 203.5 269 L 175.5 277 L 147.5 278 L 147.5 277 L 175.5 276 L 202.5 268 Q 230.2 256.2 249 235.5 Q 265.6 217.6 275 192.5 L 282 165.5 L 283.5 138 Z "
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 87.5 152 L 88 168.5 L 87 169.5 L 86.5 193 L 86 169.5 L 87 168.5 L 87.5 152 Z "
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 48.5 164 L 49 195.5 L 53 214.5 Q 60.5 239 77.5 254 Q 98.8 272.8 135 276.5 L 129.5 277 L 107.5 272 L 89.5 264 Q 76.6 255.9 67 244.5 Q 56 231 51 211.5 L 48 195.5 L 48.5 164 Z "
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 290.5 169 L 291 175.5 L 287 190.5 L 276 216.5 Q 264.5 237.5 247.5 253 Q 228.2 271.7 201.5 283 L 178.5 290 L 162.5 292 L 162.5 291 L 178.5 289 L 203.5 281 Q 232 268.5 252 247.5 Q 269.7 228.7 281 203.5 L 287 186.5 L 290.5 169 Z "
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 381.5 173 L 389 173.5 L 381.5 174 L 381.5 173 Z "
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 414.5 173 L 422 173.5 L 414.5 174 L 414.5 173 Z "
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 1005.5 173 L 1010 173.5 Q 1002 173.5 999 178.5 L 993 189.5 L 952.5 286 L 898 237.5 Q 895.2 234.8 896 228.5 L 910.5 213 L 950 175.5 L 925.5 175 L 880 219.5 Q 875 224.5 875.5 235 L 875 227.5 L 878 220.5 L 924.5 174 L 953 174.5 L 899 225.5 Q 896 227.5 897 233.5 L 910.5 248 L 947.5 281 L 953 284 L 995 182.5 L 1001.5 175 L 1005.5 173 Z "
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 1017.5 173 Q 1026.6 173.4 1030 179.5 L 1065 260.5 L 1077 292 L 1053.5 292 L 1053 290.5 L 1040.5 262 L 985.5 262 L 985 264.5 L 974 292 L 930.5 292 L 879 243.5 L 876 236.5 L 877 236.5 L 879 241.5 L 895.5 258 L 931.5 291 L 972.5 291 L 985.5 261 L 1041.5 261 L 1042 262.5 L 1054.5 291 L 1075.5 291 L 1076 289.5 L 1034 189.5 L 1027 177 Q 1024 174.3 1017.5 174 L 1017.5 173 Z "
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 376.5 174 L 380 174.5 L 376.5 175 L 376.5 174 Z "
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 423.5 174 Q 444.1 175.9 453 189.5 Q 457.5 195.5 459 204.5 L 458 204.5 Q 455 190.5 445.5 183 Q 437.5 176 423.5 175 L 423.5 174 Z "
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 479 174 L 502 174.5 L 480 175 L 479.5 275 L 479 174 Z "
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 562.5 174 L 584 174.5 L 562.5 175 L 562.5 174 Z "
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 620.5 174 L 703 174.5 L 620.5 175 L 613 180.5 L 610.5 188 L 610 184.5 L 614.5 177 L 620.5 174 Z "
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 720 174 L 743 174 L 743 222 L 803 222 L 803 174 L 826 174 L 826 291.5 L 825.5 292 L 803 292 L 803 240 L 743 240 L 743 292 L 720 292 L 720 174 Z M 721 175 L 721 291 L 742 291 L 742 239 L 804 239 L 804 291 L 825 291 L 825 291 L 825 175 L 804 175 L 804 223 L 742 223 L 742 175 L 721 175 Z "
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 846 174 L 868.5 174 L 869 174.5 L 869 292 L 846.5 292 L 846 291.5 L 846 174 Z M 847 175 L 847 291 L 848 291 L 868 291 L 868 176 L 868 175 L 847 175 Z "
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 371.5 175 L 375 175.5 Q 357.9 178.9 350 191.5 Q 345 199 343.5 210 L 343 206.5 Q 346.2 190.2 357.5 182 L 371.5 175 Z "
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 392.5 190 L 411 190.5 L 392.5 191 L 392.5 190 Z "
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 385.5 191 L 391 191.5 L 385.5 192 L 385.5 191 Z "
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 412.5 191 L 418 191.5 L 412.5 192 L 412.5 191 Z "
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 638.5 191 L 703 191.5 L 638.5 192 L 638.5 191 Z "
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 381.5 192 L 384 192.5 Q 374.3 194.8 370 202.5 L 366.5 212 L 366 209.5 Q 368.4 199.9 375.5 195 L 381.5 192 Z "
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 419.5 192 Q 429.5 194 434 201.5 L 437 210.5 L 436 210.5 L 435 205.5 L 428.5 197 L 419.5 193 L 419.5 192 Z "
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 634.5 192 L 637 192.5 L 633 195.5 L 632.5 197 L 632 194.5 L 634.5 192 Z "
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 1012.5 193 L 1016 194.5 L 1036 245.5 L 1035 245.5 L 1016 196.5 L 1013.5 194 L 1011 196.5 L 991.5 246 L 991 243.5 L 1010 196.5 L 1012.5 193 Z "
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 87.5 194 L 89 207.5 L 88 207.5 L 87.5 194 Z "
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 459.5 206 L 460 208.5 L 459 208.5 L 459.5 206 Z "
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 460.5 210 L 461 215.5 L 460 215.5 L 460.5 210 Z "
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 342.5 211 L 343 216.5 L 342 216.5 L 342.5 211 Z "
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 437.5 212 L 438 215.5 L 437 215.5 L 437.5 212 Z "
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 365.5 213 L 366 217.5 L 365 217.5 L 365.5 213 Z "
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 438.5 217 L 439 227.5 L 438 227.5 L 438.5 217 Z "
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 461.5 218 L 462 246.5 L 461 246.5 L 461.5 218 Z "
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 341.5 219 L 342 245.5 L 341 245.5 L 341.5 219 Z "
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 364.5 219 L 365 245.5 L 364 245.5 L 364.5 219 Z "
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 632.5 222 L 701.5 222 L 702 222.5 L 702 241 L 632 240.5 L 701 240 L 701 223.5 L 700.5 223 L 632.5 223 L 632.5 222 Z "
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 1240.5 227 L 1244 227.5 Q 1238.4 227.4 1237 231.5 L 1236 233.5 L 1236 292 L 1248 292.5 L 1235 293 L 1235 233.5 L 1240.5 227 Z "
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 1288.5 227 L 1289 236.5 L 1288 236.5 L 1288.5 227 Z "
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 438.5 237 L 439 247.5 L 437.5 253 L 437 248.5 L 438 247.5 L 438.5 237 Z "
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 1248 237 L 1250 237.5 L 1248 238.5 L 1248 237 Z "
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 365.5 247 L 366 251.5 L 365 251.5 L 365.5 247 Z "
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 342.5 249 L 344 258.5 L 343 258.5 L 342.5 249 Z "
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 460.5 249 L 461 254.5 L 458.5 263 L 458 260.5 L 460.5 249 Z "
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 366.5 253 Q 368.3 263.7 375.5 269 L 386 273.5 L 383.5 274 Q 373.7 271.3 369 263.5 L 366 255.5 L 366.5 253 Z "
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 436.5 254 L 437 256.5 Q 434.8 264.3 429.5 269 Q 422.4 275.4 408.5 275 L 408.5 274 Q 425.5 274.5 432 264.5 L 436.5 254 Z "
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 344.5 260 Q 347.7 275.3 358.5 283 L 373 289.5 L 370.5 290 Q 357 286 350 275.5 Q 344.8 269.3 344.5 260 Z "
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 457.5 264 L 458 265.5 Q 454.6 276.6 446.5 283 Q 437 291 420.5 292 L 420.5 291 Q 442.5 289.5 452 275.5 L 457.5 264 Z "
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 632.5 269 L 635.5 273 L 703.5 273 L 704 273.5 L 704 292 L 623 291.5 L 703 291 L 703 274.5 L 702.5 274 L 635.5 274 L 632 271.5 L 632.5 269 Z "
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 502.5 270 L 503 272 L 505.5 273 L 562 273.5 L 505.5 274 L 502 271.5 L 502.5 270 Z "
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 584.5 273 L 600 273.5 L 584.5 274 L 584.5 273 Z "
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 387.5 274 L 395 274.5 L 387.5 275 L 387.5 274 Z "
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 136.5 277 L 146 277.5 L 136.5 278 L 136.5 277 Z "
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 610.5 277 Q 610.1 286.4 616.5 289 L 621 290.5 L 618.5 291 L 613 287.5 Q 608.5 284.3 610.5 277 Z "
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 480.5 278 Q 480.9 285.1 485.5 288 L 492 290.5 L 488.5 291 L 481 284.5 L 480.5 278 Z "
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 374.5 290 L 377 290.5 L 374.5 291 L 374.5 290 Z "
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 378.5 291 L 384 291.5 L 378.5 292 L 378.5 291 Z "
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 494.5 291 L 600 291.5 L 494.5 292 L 494.5 291 Z "
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 132.5 292 L 161 292.5 L 132.5 293 L 132.5 292 Z "
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 386.5 292 L 418 292.5 L 386.5 293 L 386.5 292 Z "
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 0.5 414 L 2166 414.5 L 0.5 415 L 0.5 414 Z "
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(238,127,26)",
    stroke: "rgb(238,127,26)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 0.5 570 L 2166 570.5 L 0.5 571 L 0.5 570 Z "
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 0 L 147.5 1 L 162.5 1 L 163.5 2 L 175.5 3 L 201.5 11 Q 232.7 24.3 254 47.5 L 275 76.5 L 286 102.5 L 290 117.5 L 290 123.5 L 292 131.5 L 292 160.5 L 291 161.5 L 290 175.5 L 281 203.5 Q 268.5 231 248.5 251 Q 225.9 273.4 192.5 285 L 161.5 292 L 131.5 292 L 114.5 289 L 89.5 281 Q 60.9 268.6 41 247.5 Q 19.7 225.3 8 193.5 L 3 175.5 L 3 169.5 L 1 162.5 L 1 130.5 L 6 105.5 L 18 76.5 Q 29.9 54.9 47.5 39 Q 67.7 19.7 96.5 9 L 117.5 3 L 129.5 2 L 130.5 1 L 145.5 1 L 146.5 0 Z M 143 14 L 142 15 L 130 15 L 129 16 L 117 17 L 93 24 Q 71 32 56 46 Q 38 60 26 81 L 15 105 L 11 122 L 10 137 L 9 138 L 9 158 L 10 159 L 10 167 L 12 178 L 19 199 L 28 216 L 29 216 L 28 204 L 27 203 L 27 188 L 28 187 L 29 169 L 36 140 L 52 104 L 67 82 L 82 69 L 93 65 L 102 68 Q 107 74 110 83 L 112 93 L 112 102 L 113 103 L 113 141 L 112 142 L 111 175 L 110 176 L 110 206 L 111 209 Q 112 211 116 210 L 122 203 L 131 185 L 149 140 L 163 110 L 182 80 Q 189 68 205 65 L 212 67 L 220 78 L 223 87 L 224 99 L 225 100 L 225 138 L 224 139 L 224 153 L 223 154 L 223 168 L 222 169 L 222 183 L 221 184 L 221 201 L 223 209 L 226 210 L 230 209 L 236 202 L 246 181 L 253 155 L 255 145 L 255 137 L 256 136 L 256 108 L 255 107 L 255 99 L 253 89 L 243 64 L 231 48 Q 216 32 194 23 L 172 17 L 143 14 Z M 84 82 L 81 83 L 72 92 L 61 112 L 51 144 L 50 155 L 49 156 L 49 164 L 48 165 L 48 196 L 51 212 Q 56 231 67 245 Q 80 260 100 269 L 119 275 L 136 277 L 137 278 L 168 278 L 189 274 Q 217 265 238 248 Q 254 233 266 215 L 278 188 L 282 172 L 283 158 L 284 157 L 283 127 L 279 108 L 274 96 L 273 96 L 275 107 L 274 128 L 270 150 L 259 181 Q 252 199 240 213 Q 233 223 221 227 Q 212 228 210 224 Q 204 218 202 210 L 201 197 L 200 196 L 200 152 L 201 151 L 201 134 L 202 133 L 202 91 L 201 87 Q 200 82 195 83 L 189 89 L 185 96 L 153 170 L 140 195 L 128 213 Q 122 222 110 227 L 100 226 Q 94 222 91 215 L 89 209 L 88 195 L 87 194 L 87 170 L 88 169 L 90 122 L 91 121 L 91 94 L 89 86 L 84 82 Z "
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 443.5 0 L 452.5 2 L 457 5 L 461 12.5 Q 459.5 18 462 19.5 L 462 124 L 439 124 L 439 83.5 L 440 82.5 L 440 27 Q 436.2 26 435 28.5 L 383 113.5 L 375.5 122 Q 370 127 357.5 125 L 349 119.5 L 346 112.5 L 346 2 L 367.5 2 L 368 2.5 L 368 75.5 L 367 76.5 L 367 96.5 L 368 99 Q 371.8 99.8 373 96.5 L 423 13.5 L 432.5 3 L 443.5 0 Z "
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1258.5 1 Q 1269.3 -0.8 1272 5.5 L 1297 66 L 1285.5 66 L 1285 63.5 L 1279 49 L 1247.5 49 L 1246 50.5 L 1239.5 66 L 1228 65.5 L 1250 12.5 L 1256.5 2 L 1258.5 1 Z M 1263 11 L 1259 17 L 1250 41 L 1276 41 L 1264 13 Q 1265 10 1263 11 Z "
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 483 2 L 506 2 L 506 52 L 570 52 L 570 2 L 593 2 L 593 123.5 L 592.5 124 L 570 124 L 570 70 L 506 70 L 506 124 L 483 124 L 483 2 Z "
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1236 114 L 1247.5 114 L 1248 114.5 L 1248 179 L 1236.5 179 L 1236 178.5 L 1236 114 Z "
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1280.5 114 L 1294 114.5 L 1264 142.5 L 1263 147.5 L 1265.5 151 L 1297 178.5 L 1282.5 179 L 1254 151.5 L 1252 145.5 L 1254 140.5 L 1280.5 114 Z "
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 389.5 173 L 413.5 173 L 414.5 174 L 422.5 174 L 431.5 176 Q 443.8 179.8 451 188.5 Q 457.3 197.2 460 209.5 Q 458.5 215 461 216.5 L 461 248.5 L 456 268.5 Q 452 277.5 444.5 283 L 435.5 288 L 419.5 292 L 384.5 292 L 367.5 288 Q 357.8 284.2 352 276.5 L 347 268.5 L 343 254.5 Q 344.3 249.7 342 248.5 L 342 217.5 L 345 202.5 L 350 191.5 L 360.5 181 L 375.5 175 L 388.5 174 L 389.5 173 Z M 393 190 L 382 192 L 376 195 Q 370 199 367 207 L 364 220 L 364 246 L 369 264 Q 375 273 388 275 L 416 275 L 430 269 L 436 260 L 439 248 L 439 218 L 434 202 Q 430 195 422 192 L 411 190 L 393 190 Z "
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1010.5 173 Q 1021.5 172.8 1027 177 L 1034 189.5 L 1076 291 L 1054.5 291 L 1053 289.5 L 1042 261 L 985.5 261 L 984 262.5 L 972.5 291 L 931.5 291 L 879 241.5 L 876 235.5 L 876 227.5 L 880 219.5 L 900.5 199 L 925.5 175 L 949.5 175 L 932.5 193 L 897 226.5 L 896 233.5 Q 899 241 905.5 245 L 952.5 286 L 993 189.5 L 1000.5 177 L 1005.5 174 L 1010.5 173 Z M 1013 193 L 1010 197 L 991 244 L 992 246 L 1036 246 L 1016 195 L 1013 193 Z "
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 480 175 L 501.5 175 L 502 175.5 L 502 266.5 L 501 268.5 L 503.5 273 L 505.5 274 L 562 274 L 562 175.5 L 562.5 175 L 584 175 L 584 273.5 L 584.5 274 L 600 274 L 600 291 L 492.5 291 Q 485.9 290.1 483 285.5 L 480 277.5 L 480 175 Z "
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 620.5 175 L 702.5 175 L 703 175.5 L 703 191 L 638.5 191 L 634.5 192 L 632 194.5 L 632 223 L 700.5 223 L 701 223.5 L 701 240 L 632 240 L 632 271.5 L 635.5 274 L 703 274 L 703 290.5 L 702.5 291 L 621.5 291 Q 615 289.5 612 284.5 L 610 276.5 L 610 188.5 Q 611.2 180.7 616.5 177 L 620.5 175 Z "
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 721 175 L 742 175 L 742 223 L 804 223 L 804 175 L 825 175 L 825 290.5 L 824.5 291 L 804 291 L 804 239 L 742 239 L 742 291 L 721 291 L 721 175 Z "
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 847 175 L 867.5 175 L 868 175.5 L 868 291 L 847.5 291 L 847 290.5 L 847 175 Z "
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1244.5 227 L 1287.5 227 L 1288 227.5 L 1288 237 L 1248 237 L 1248 291.5 L 1247.5 292 L 1236 292 L 1236 233.5 L 1240.5 228 L 1244.5 227 Z "
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 415 L 2165.5 415 L 2166 415.5 L 2166 570 L 0.5 570 L 0 569.5 L 0 415 Z M 83 458 L 72 462 L 65 469 L 61 481 L 61 503 L 66 516 L 71 520 L 85 525 Q 107 528 119 520 L 125 513 L 128 502 L 128 481 L 124 469 Q 120 461 111 459 L 107 458 L 83 458 Z M 139 458 L 139 519 L 140 521 L 145 524 L 206 524 L 206 514 L 198 514 L 197 514 L 197 458 L 186 458 L 185 459 L 185 514 L 152 514 L 151 512 L 151 459 L 151 458 L 139 458 Z M 223 458 L 216 460 L 212 467 L 212 517 L 214 522 L 218 524 L 265 524 L 265 515 L 265 514 L 227 514 L 225 513 L 225 496 L 263 496 L 264 495 L 264 487 L 264 486 L 225 486 L 225 471 L 227 469 L 264 469 L 265 468 L 265 460 L 264 458 L 223 458 Z M 275 458 L 275 524 L 287 524 L 287 495 L 321 495 L 321 524 L 334 524 L 334 524 L 334 460 L 333 458 L 323 458 L 321 460 L 321 485 L 287 485 L 287 458 L 275 458 Z M 348 458 L 346 460 L 346 524 L 359 524 L 359 524 L 359 460 L 358 458 L 348 458 Z M 392 458 L 390 459 L 364 485 L 362 489 L 364 497 L 394 524 L 418 524 L 424 510 L 425 508 L 456 508 L 458 512 L 462 524 L 476 524 L 450 463 L 445 458 Q 436 457 432 460 L 406 521 L 382 500 L 374 492 L 375 488 L 404 460 L 405 460 L 405 458 L 392 458 Z M 623 458 L 623 469 L 653 469 L 657 471 L 662 477 L 664 485 L 664 486 L 624 486 L 624 496 L 625 496 L 664 496 L 662 507 Q 659 512 652 514 L 623 514 L 622 515 L 622 524 L 657 524 L 667 520 Q 672 516 675 509 L 676 497 L 677 496 L 676 478 L 673 470 Q 668 461 658 459 Q 652 461 651 458 L 623 458 Z M 689 458 L 687 460 L 687 524 L 700 524 L 700 524 L 700 460 L 699 458 L 689 458 Z M 733 458 L 731 459 L 705 485 L 703 490 L 705 497 L 735 524 L 749 524 L 722 499 Q 716 497 715 491 L 716 488 L 746 460 L 746 458 L 733 458 Z M 780 458 Q 778 461 772 459 L 763 463 L 755 473 L 752 488 L 753 505 L 758 516 Q 763 522 773 524 L 808 524 L 808 524 L 808 516 L 807 514 L 778 514 L 773 512 L 766 504 Q 768 498 765 497 L 766 481 L 768 476 Q 770 470 777 469 L 806 469 L 807 468 L 807 460 L 806 458 L 780 458 Z M 827 458 L 821 460 L 817 467 L 817 524 L 818 524 L 830 524 L 830 471 L 832 469 L 863 469 L 863 524 L 864 524 L 876 524 L 876 466 L 875 463 L 872 459 L 867 458 L 827 458 Z M 899 458 L 892 460 L 888 468 L 888 516 L 890 522 L 894 524 L 941 524 L 941 515 L 941 514 L 903 514 L 901 513 L 901 496 L 939 496 L 940 495 L 940 487 L 940 486 L 901 486 L 901 471 L 903 469 L 940 469 L 941 468 L 941 460 L 940 458 L 899 458 Z M 961 458 L 955 460 L 951 465 L 951 524 L 963 524 L 963 501 L 998 501 L 1003 499 L 1007 495 L 1010 485 L 1010 475 L 1006 464 L 1000 459 Q 995 460 994 458 L 961 458 Z M 1014 458 L 1014 469 L 1039 469 L 1039 524 L 1052 524 L 1052 524 L 1052 469 L 1077 469 L 1078 468 L 1078 460 L 1077 458 L 1014 458 Z M 1085 458 L 1083 460 L 1083 514 L 1085 522 L 1091 525 Q 1098 526 1101 523 L 1132 473 L 1134 474 L 1134 508 L 1133 509 L 1133 524 L 1146 524 L 1146 466 L 1145 463 L 1140 458 L 1131 459 L 1123 468 L 1098 510 L 1096 510 L 1096 459 L 1096 458 L 1085 458 Z M 1158 458 L 1158 469 L 1159 469 L 1195 469 L 1197 472 L 1197 483 L 1193 486 L 1160 486 L 1159 487 L 1159 496 L 1194 496 L 1196 497 L 1199 503 Q 1200 511 1195 514 L 1159 514 L 1158 515 L 1158 524 L 1200 524 L 1206 522 L 1209 519 L 1212 510 L 1211 499 L 1209 495 L 1202 491 L 1206 489 L 1210 483 L 1210 469 L 1208 465 L 1201 459 Q 1196 460 1195 458 L 1158 458 Z M 1246 458 L 1244 459 L 1238 466 L 1214 524 L 1227 524 L 1233 510 L 1234 508 L 1265 508 L 1273 524 L 1285 524 L 1259 463 Q 1256 456 1246 458 Z M 1433 458 L 1433 524 L 1434 524 L 1445 524 L 1445 459 L 1445 458 L 1433 458 Z M 1478 458 L 1455 480 L 1449 488 Q 1448 496 1452 499 L 1480 524 L 1495 524 L 1465 497 Q 1460 495 1461 489 L 1491 460 L 1491 458 L 1478 458 Z M 1520 458 L 1509 462 Q 1500 467 1498 480 L 1498 503 L 1503 516 L 1511 522 L 1522 525 Q 1544 528 1556 520 L 1560 516 L 1565 502 L 1565 481 L 1561 469 Q 1557 461 1548 459 L 1544 458 L 1520 458 Z M 1576 458 L 1576 524 L 1588 524 L 1588 495 L 1622 495 L 1622 524 L 1635 524 L 1635 524 L 1635 460 L 1634 458 L 1624 458 L 1622 460 L 1622 485 L 1588 485 L 1588 458 L 1576 458 Z M 1673 458 Q 1671 461 1665 459 L 1656 463 L 1648 473 L 1645 488 L 1646 504 L 1651 516 Q 1656 522 1666 524 L 1701 524 L 1701 524 L 1701 516 L 1700 514 L 1671 514 L 1666 512 L 1659 504 Q 1661 498 1658 497 L 1659 481 L 1661 476 Q 1663 470 1670 469 L 1699 469 L 1700 468 L 1700 460 L 1699 458 L 1673 458 Z M 1734 458 L 1732 459 L 1725 469 L 1702 524 L 1715 524 L 1721 511 L 1722 508 L 1754 508 L 1759 523 L 1761 524 L 1782 524 L 1803 472 Q 1802 469 1805 470 L 1826 523 L 1827 524 L 1839 524 L 1814 463 L 1809 458 Q 1800 457 1797 460 L 1772 516 Q 1773 519 1770 518 L 1748 464 Q 1745 456 1734 458 Z M 1839 458 L 1837 460 L 1837 468 L 1839 469 L 1863 469 L 1863 524 L 1875 524 L 1875 524 L 1875 469 L 1900 469 L 1901 468 L 1901 460 L 1900 458 L 1839 458 Z M 1907 458 L 1907 519 L 1908 521 L 1914 525 L 1923 524 L 1930 515 L 1954 475 L 1957 473 L 1957 524 L 1958 524 L 1969 524 L 1969 465 L 1968 463 L 1963 458 L 1954 459 L 1947 467 L 1921 510 L 1919 510 L 1919 459 L 1919 458 L 1907 458 Z M 1982 458 L 1982 524 L 1994 524 L 1994 495 L 2028 495 L 2028 524 L 2041 524 L 2041 524 L 2041 460 L 2040 458 L 2030 458 L 2028 460 L 2028 485 L 1994 485 L 1994 458 L 1982 458 Z M 2063 458 L 2057 460 L 2053 467 L 2053 524 L 2066 524 L 2066 524 L 2066 469 L 2106 469 L 2106 459 L 2106 458 L 2063 458 Z M 541 473 L 535 476 Q 529 480 527 487 Q 525 498 530 503 Q 534 508 541 510 Q 552 512 557 507 Q 562 503 564 496 Q 565 484 560 480 L 551 473 L 541 473 Z M 1350 473 L 1343 477 L 1336 488 Q 1335 498 1339 503 Q 1343 508 1350 510 Q 1361 512 1366 507 Q 1371 503 1373 497 Q 1375 485 1370 481 Q 1366 475 1360 473 L 1350 473 Z "
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 468 L 102.5 468 Q 109.1 468.9 112 473.5 L 115 481.5 L 115 501.5 L 111 511 Q 103.8 517 87.5 515 L 78 511 L 74 501.5 L 74 481.5 Q 75.2 473.7 80.5 470 L 86.5 468 Z "
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1523.5 468 L 1539.5 468 Q 1546.1 468.9 1549 473.5 L 1552 481.5 L 1552 500.5 L 1550 507.5 L 1544.5 513 Q 1537.3 516.8 1524.5 515 L 1515 510.5 L 1511 501.5 L 1511 480.5 Q 1512.5 473.6 1517.5 470 L 1523.5 468 Z "
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 964.5 469 L 992.5 469 L 996 472.5 L 997 483.5 L 993.5 490 L 991.5 491 L 963 491 L 963 470.5 L 964.5 469 Z "
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1249.5 469 L 1262 498.5 L 1237 499 L 1247 472.5 L 1249.5 469 Z "
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1737.5 469 L 1740 472.5 L 1750 499 L 1725.5 499 L 1725 497.5 L 1737.5 469 Z "
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,127,26)",
    stroke: "rgb(239,127,26)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 439 470 L 442 471.5 L 452 499 L 428.5 499 L 428 497.5 L 439 470 Z "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInvestocenka3);
export default __webpack_public_path__ + "static/media/logoInvestocenka3.12269f54e8f872ab0e22cdd5eac9d7d8.svg";
export { ForwardRef as ReactComponent };